import React, { Component } from "react";
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonBackButton,
  IonButtons,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonModal,
  IonImg,
  IonLabel,
  IonInput,
  IonGrid,
  IonRow,
  IonText,
  IonSelect,
  IonSelectOption,
  IonCol,
  IonAlert,
  IonSlides,
  IonSlide,
  IonPage,
  IonSpinner,
  withIonLifeCycle,
  IonPopover,
} from "@ionic/react";
import { isPlatform } from "@ionic/core";

import { App, AppState } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { TextToSpeech, TTSOptions } from "@capacitor-community/text-to-speech";

import { RouteComponentProps, withRouter } from "react-router";
import { TransformWrapper, TransformComponent, ReactZoomPanPinchRef } from "react-zoom-pan-pinch";

import _ from "lodash";
import { format, addYears } from "date-fns";

// Images
import iconSearchInactive from "../../assets/Button_Page Search_1 Default@3x.png";
import iconSearchActive from "../../assets/Button_Page Search_2 Active@3x.png";
import iconBookmarkActive from "../../assets/Button_Bookmark_2Active@3x.png";
import iconBookmarkInactive from "../../assets/Button_Bookmark_1Inactive@3x.png";
import iconSearch from "../../assets/Button_Search_Small@3x.png";
import iconSearchDark from "../../assets/Button_Search_Small_Dark@3x.png";

import iconPlus from "../../assets/Button_Expand_Add@3x.png";
import iconPlusDark from "../../assets/Button_Expand_Add_Dark@3x.png";
import iconMinus from "../../assets/Button_Expand_Minus@3x.png";
import iconMinusDark from "../../assets/Button_Expand_Minus_Dark@3x.png";
import indicatorUpdate from "../../assets/Indicator_Update@3x.png";
import buttonClose from "../../assets/Button_Close@3x.png";
import iconAccessibility from "../../assets/Button_Accessibility@3x.png";
import buttonDown from "../../assets/Button_Disclosure_Down@3x.png";
import buttonUp from "../../assets/Button_Disclosure_Up@3x.png";
import jrcalcLogo from "../../assets/logo_jrcalc@2x.png";
import iconParaPass from "../../assets/Icon_ParaPass@3x.png";
import iconPlay from "../../assets/Button_Audio_Play@3x.png";
import iconPlayDark from "../../assets/Button_Audio_Play_Dark@3x.png";
import iconPlayWhite from "../../assets/Button_Audio_Play_White@3x.png";
import iconStop from "../../assets/Button_Audio_Stop@3x.png";

// CSS
import "./GuidelinePage.css";
import "../../Shared.css";
import "../../../App.css";
import "../../css/CM.css";
import "../../css/style.css";
import "../../css/style2.css";

// import '../../css/EMAS.css';
// import '../../css/LAS.css';
// import '../../css/NEAS.css';
// import '../../css/NIAS.css';
// import '../../css/NWAS.css';
// import '../../css/SAS.css';
// import '../../css/SCAS.css';
// import '../../css/SJA.css';
// import '../../css/SWAST.css';
// import '../../css/WAS.css';
// import '../../css/WMAS.css';
// import '../../css/YAS.css';

// Controllers
import {
  IScreenProps,
  IUser,
  IGuideline,
  ISignificantChange,
  IGuidelineSummary,
  IAbbreviation,
  IReferenceCard,
  IPGDAck,
  IPatientAge,
} from "../../Interfaces";
import AppController from "../../../controllers/AppController";
import DataController from "../../controllers/DataController";
import RemoteDataController from "../../controllers/RemoteDataController";
import * as TableHandler from "../../controllers/AACETableHandler";
import TrustRender from "../../controllers/plusstatic/TrustRender";

// Componenets
import AgeSelector from "../../components/AgeSelector";
import SignificantChangeWarningCard from "../../components/SignificantChangeWarningCard";
import FontPopover from "../../components/FontPopover";
import { isPageForAge } from "../../controllers/AACETableHandler";
import ImageViewerModal from "../../components/ImageViewerModal";

const parser = new DOMParser();
let back: any;
let appStateListener: any;

// Components

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  guidelineSummary: IGuidelineSummary | undefined;
  guideline: IGuideline | null | undefined;
  selectedGLID: string;
  sections: [];
  hasUpdate: boolean;
  displayParaPassQuizLink: boolean;
  abbreviations: IAbbreviation[];
  drugModalVisible: boolean;
  drugModalFiltered: boolean;
  drug2ModalVisible: boolean;
  drug2ModalFiltered: boolean;
  fontModalVisible: boolean;
  fontModalEvent: any;
  selectedAbbreviation: IAbbreviation | null;
  abbreviationPopoverVisible: boolean;
  abbreviationPopoverEvent: any;
  imageModalVisible: boolean;
  bookmarkSuggestionModalVisible: boolean;
  bookmarkSuggestionModalEvent: any;
  drugModalTable: any;
  drug2ModalTable: any;
  imageSrc: any;
  textActive: boolean;
  showSearch: boolean;
  searchText: string;
  searchIndex: number;
  searchOccurences: number;
  alertOpen: boolean;
  unavailable: any;
  waitingForPGDAcknowledgement: boolean;
  waitingForGLAcknowledgement: boolean;
  isReferenceCard: boolean;
  referenceCard: IReferenceCard | null | undefined;
  currentReferenceCardIndex: number;
  pageStateHistory: { glid: string; scrollPosition: number; openSections: number[] }[];
  remainingTextToSpeechText: string;
  toggleSectionsText: string;
  scrollPosition: number;
  firstOpen: boolean;
};

let useInnodataGuidelines = false;

class GuidelinePage extends Component<Props, State> {
  private searchTextField: React.RefObject<HTMLIonInputElement>;
  private imageModalZoom: React.RefObject<ReactZoomPanPinchRef>;
  private ionContent: React.RefObject<HTMLIonContentElement>;
  private ionContentDrugModal: React.RefObject<HTMLIonContentElement>;
  private ionContentDrugModal2: React.RefObject<HTMLIonContentElement>;

  constructor(props: Props) {
    super(props);

    this.searchTextField = React.createRef();
    this.imageModalZoom = React.createRef();
    this.ionContent = React.createRef();
    this.ionContentDrugModal = React.createRef();
    this.ionContentDrugModal2 = React.createRef();

    let selectedGLID = props.match.url.substr(props.match.url.lastIndexOf("/") + 1);

    let guidelineSummary = _.find(this.props.screenProps.guidelineSummaries, { GLID: selectedGLID });

    this.state = {
      guidelineSummary: guidelineSummary,
      guideline: null,
      selectedGLID: selectedGLID,
      sections: [],
      hasUpdate: false,
      displayParaPassQuizLink: false,
      abbreviations: [],
      drugModalVisible: false,
      drugModalFiltered: false,
      drug2ModalVisible: false,
      drug2ModalFiltered: false,
      fontModalVisible: false,
      fontModalEvent: null,
      abbreviationPopoverVisible: false,
      abbreviationPopoverEvent: null,
      selectedAbbreviation: null,
      imageModalVisible: false,
      bookmarkSuggestionModalVisible: false,
      bookmarkSuggestionModalEvent: null,
      textActive: false,
      showSearch: false,
      searchText: "",
      searchIndex: 0,
      searchOccurences: 0,
      alertOpen: false,
      unavailable: {},
      drugModalTable: "",
      drug2ModalTable: "",
      imageSrc: "",
      waitingForPGDAcknowledgement: false,
      waitingForGLAcknowledgement: false,
      isReferenceCard: false,
      referenceCard: null,
      currentReferenceCardIndex: 0,
      pageStateHistory: [],
      remainingTextToSpeechText: "",
      toggleSectionsText: "Expand all",
      scrollPosition: window.scrollY,
      firstOpen: true,
    };
  }

  async componentDidMount() {
    if (this.state.guidelineSummary != null) {
      let guideline = await DataController.getGuideline(this.state.guidelineSummary);
      await this.setStateAsync({ guideline });
    }

    if (this.props.screenProps.user) {
      let abbreviations = await DataController.getAbbreviations(this.props.screenProps.trust);
      await this.setStateAsync({ abbreviations });
    }

    this.configureGuideline();

    document.addEventListener("click", this.handleClickEvent);
    // document.addEventListener("selectionchange", this.handleSelectionChangeEvent);

    appStateListener = App.addListener("appStateChange", (state: AppState) => {
      if (state.isActive == true) {
        if (this.state.guidelineSummary && DataController.isAuthorisableGuideline(this.state.guidelineSummary)) {
          this.props.screenProps.checkPGDRemoteStatus(this.state.guidelineSummary);
        }
      }
    });

    let bookmarkSuggestionAlreadyDismissed = await DataController.getBookmarkSuggestionDismissed();
    if (this.props.screenProps.abTestingVersion === "B" && bookmarkSuggestionAlreadyDismissed === false) {
      setTimeout(() => {
        let bookmarkSuggestionElement = document.getElementById("bookmarkSuggestion");
        bookmarkSuggestionElement?.click();
      }, 500);
    }
  }

  async componentDidUpdate(prevProps: Props, prevState: State) {
    let shouldConfigureGuideline = false;

    if (prevProps.screenProps.guidelineSummaries != this.props.screenProps.guidelineSummaries) {
      // guidelines have been updated

      let guidelineSummary = this.state.guidelineSummary;

      if (this.state.guidelineSummary == null) {
        let selectedGLID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
        guidelineSummary = _.find(this.props.screenProps.guidelineSummaries, { GLID: selectedGLID });
      }

      if (_.isEqual(guidelineSummary, this.state.guidelineSummary) === false) {
        await this.setStateAsync({ guidelineSummary });
      }

      if (guidelineSummary != null) {
        let guideline = await DataController.getGuideline(guidelineSummary);

        if (_.isEqual(guideline, this.state.guideline) === false) {
          await this.setStateAsync({ guideline });

          shouldConfigureGuideline = true;
        }
      }
    }

    if (prevProps.screenProps.hideParaPassLinks !== this.props.screenProps.hideParaPassLinks) {
      shouldConfigureGuideline = true;
    }
    if (prevProps.screenProps.freezeFirstDrugColumn !== this.props.screenProps.freezeFirstDrugColumn) {
      shouldConfigureGuideline = true;
    }

    if (
      this.state.searchText != prevState.searchText ||
      this.props.screenProps.fontSizeChange !== prevProps.screenProps.fontSizeChange ||
      this.props.screenProps.lineHeightChange !== prevProps.screenProps.lineHeightChange ||
      this.props.screenProps.showTextToSpeech !== prevProps.screenProps.showTextToSpeech ||
      this.props.screenProps.patientAge !== prevProps.screenProps.patientAge ||
      this.props.screenProps.darkMode !== prevProps.screenProps.darkMode ||
      this.props.screenProps.images !== prevProps.screenProps.images ||
      this.props.screenProps.annotations !== prevProps.screenProps.annotations
    ) {
      this.setState({ sections: this.generateSections(this.state.guideline) });
    }

    if (shouldConfigureGuideline) {
      this.configureGuideline();
    }

    // possibly navigating to a different guideline so check if need to update
    if (this.state.guidelineSummary != null) {
      let selectedGLID = this.props.match.url.substr(this.props.match.url.lastIndexOf("/") + 1);
      if (selectedGLID !== this.state.guidelineSummary.GLID) {
        let guidelineSummary = _.find(this.props.screenProps.guidelineSummaries, { GLID: selectedGLID });
        if (guidelineSummary != null) {
          let guideline = await DataController.getGuideline(guidelineSummary);
          await this.setStateAsync({ guidelineSummary, guideline });

          this.configureGuideline();
        }
      }
    }

    if (this.state.searchText.length > 1) {
      this.highlightFirst();
    }
  }

  async configureGuideline() {
    if (this.state.guidelineSummary != null && this.state.guideline != null && this.props.screenProps.user != null) {
      if (useInnodataGuidelines) {
        await RemoteDataController.downloadGuideline(this.state.guidelineSummary);
        let guideline = await DataController.getGuideline(this.state.guidelineSummary);
        await this.setStateAsync({ guideline });
      }

      // check if user has a parapass subscription - if so show link at bottom of the page
      let displayParaPassQuizLink = await DataController.guidelineHasParaPassQuiz(this.state.guidelineSummary.GLID);
      if (DataController.isAuthorisableGuideline(this.state.guidelineSummary)) {
        displayParaPassQuizLink = false;
      }
      let userHasAParaPassSubscription = false;
      if (displayParaPassQuizLink && this.props.screenProps.user && this.props.screenProps.user.subscriptions) {
        userHasAParaPassSubscription = DataController.hasParaPassSubscription(
          this.props.screenProps.user.subscriptions
        );
      }
      if (userHasAParaPassSubscription === false) {
        displayParaPassQuizLink = false;
      }

      if (this.props.screenProps.hideParaPassLinks) {
        displayParaPassQuizLink = false;
      }

      this.setState({ displayParaPassQuizLink });

      await this.props.screenProps.saveRecentlyViewed(this.state.guideline.GLID, null, null, null, "guideline");

      RemoteDataController.logUsage(
        this.state.guideline,
        null,
        null,
        null,
        null,
        false,
        "",
        this.props.screenProps.user,
        this.props.screenProps.app
      );
      DataController.logLocalUsage(
        this.state.guidelineSummary,
        null,
        null,
        null,
        null,
        null,
        this.props.screenProps.user.email
      );

      this.props.screenProps.updateGuidelineLastOpenedVersion(this.state.guidelineSummary);

      this.setState({ sections: this.generateSections(this.state.guideline) });
    }

    this.resetCards();

    let pageStateFound = false;
    if (this.ionContent && this.ionContent.current && this.state.guidelineSummary) {
      for (let pageState of this.state.pageStateHistory) {
        if (pageState.glid === this.state.guidelineSummary.GLID) {
          for (let section of pageState.openSections) {
            this.openSection(section, true);
          }
          // alert(pageState.scrollPosition);
          setTimeout(() => {
            if (this.ionContent && this.ionContent.current) {
              this.ionContent.current.scrollToPoint(0, pageState.scrollPosition);
            }
          }, 100);
          pageStateFound = true;
        }
      }
    }
    if (pageStateFound === false) {
      if (this.ionContent && this.ionContent.current) {
        this.ionContent.current.scrollToPoint(0, 0);
      }
    }

    if (this.props.location && this.props.location.state != null) {
      let locationState: any = this.props.location.state;
      if (locationState.searchTerm && locationState.searchTerm !== "") {
        this.toggleSearch(false);
        setTimeout(() => {
          this.searchValueChanged(locationState.searchTerm);
        }, 500);
      }

      if (locationState.figure && locationState.figure !== "") {
        this.goToFigure(locationState.figure);
      }

      if (locationState.sectionName && locationState.sectionName !== "") {
        this.goToSubsectionWithName(locationState.sectionName);
      }

      if (locationState.subsection && locationState.subsection !== "") {
        this.goToSubsection(locationState.subsection);
      }

      if (locationState.table && locationState.table !== "") {
        this.goToTable(locationState.table);
      }

      if (locationState.id && locationState.id !== "") {
        this.goToId(locationState.id);
      }

      if (locationState.isReferenceCard) {
        await this.setStateAsync({ isReferenceCard: true, referenceCard: locationState.referenceCard });
        if (locationState.referenceCard == null || locationState.referenceCard.dontDisplayImage !== true) {
          this.openReferenceCard(0);
        }
      }
    }

    this.setState({ firstOpen: false });
  }

  ionViewDidEnter() {
    // back = App.addListener('backButton', () => {
    //   if (this.state.drugModalVisible) {
    //     this.setState({drugModalVisible: false, drugModalFiltered: false});
    //   } else if (this.state.drug2ModalVisible) {
    //     this.setState({drug2ModalVisible: false, drug2ModalFiltered: false});
    //   } else if (this.state.fontModalVisible) {
    //     this.setState({fontModalVisible: false});
    //   } else if (this.state.abbreviationPopoverVisible) {
    //     this.setState({abbreviationPopoverVisible: false});
    //   } else if (this.state.imageModalVisible) {
    //     this.setState({imageModalVisible: false});
    //   } else if (this.state.showSearch) {
    //     this.toggleSearch(false);
    //   }
    // });

    if (this.state.guidelineSummary && DataController.isAuthorisableGuideline(this.state.guidelineSummary)) {
      this.props.screenProps.checkPGDRemoteStatus(this.state.guidelineSummary);
    }
  }

  ionViewWillLeave() {
    // back.remove();
    this.stopReading();
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickEvent);
    // document.removeEventListener("selectionchange", this.handleSelectionChangeEvent);

    if (appStateListener) {
      appStateListener.remove();
    }
  }

  highlightFirst() {
    let content;
    let tab = this.props.match.params.tab;
    let highlighted;
    let selected;

    if (tab === "dashboard") {
      content = document.getElementById("dashboard-guideline-content");
    } else if (tab === "guidelines") {
      content = document.getElementById("guidelines-guideline-content");
    } else if (tab === "meds") {
      content = document.getElementById("meds-guideline-content");
    } else if (tab === "pageforage") {
      content = document.getElementById("pageforage-guideline-content");
    }

    if (content !== null && content !== undefined) {
      highlighted = content.getElementsByClassName("searchHighlight");
      selected = content.getElementsByClassName("searchHighlightCurrent");
    }

    if (highlighted !== undefined && selected !== undefined && highlighted.length > 0) {
      if (selected.length === 0) {
        highlighted[0].className = "searchHighlight searchHighlightCurrent";
        this.scrollToHighlight(highlighted[0], "center");
      }
    }
  }

  handleClickEvent = (event: any) => {
    if (typeof event.srcElement.className !== "string") {
      return;
    }

    if (event.srcElement.className.includes("searchHighlight")) {
      if (event.srcElement.parentElement) {
        event.srcElement.parentElement.click();
        return;
      }
    }

    if (event.srcElement.localName === "th" && event.srcElement.innerText.toLowerCase() !== "age") {
      let elementID = event.srcElement.id;
      let singleTableID = elementID.substring(elementID.lastIndexOf("-"), 0).replace("th-", "");
      let singleTableRowColumn = parseInt(elementID.substring(elementID.lastIndexOf("-") + 1));

      if (singleTableID === "" || isNaN(singleTableRowColumn)) {
        singleTableID = null;
        singleTableRowColumn = -1;
      }

      if (this.state.drugModalVisible) {
        // drug modal already open so open a second one
        let succeeded = this.generateModalTable(
          this.state.guideline,
          event.srcElement,
          singleTableID,
          singleTableRowColumn
        );
        if (succeeded === undefined) {
          if (this.props.match.url === event.currentTarget.location.pathname) {
            this.toggleDrug2Modal(true);

            try {
              if (this.state.guidelineSummary) {
                RemoteDataController.logEvent("med_navigation", {
                  name: "Dosage table age selected",
                  value: event.srcElement.innerText,
                  glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
                });
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      } else {
        let succeeded = this.generateModalTable(
          this.state.guideline,
          event.srcElement,
          singleTableID,
          singleTableRowColumn
        );
        if (succeeded === undefined) {
          if (this.props.match.url === event.currentTarget.location.pathname) {
            this.toggleDrugModal(true);

            try {
              if (this.state.guidelineSummary) {
                RemoteDataController.logEvent("med_navigation", {
                  name: "Dosage table age selected",
                  value: event.srcElement.innerText,
                  glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
                });
              }
            } catch (error) {
              console.log(error);
            }
          }
        }
      }
    }

    if (
      event.srcElement.localName === "td" ||
      (event.srcElement.localName === "img" &&
        event.srcElement.currentSrc.includes("Fullscreen") &&
        event.srcElement.parentElement.localName === "td") ||
      (event.srcElement.className.includes("DrugAnnoTextPFA") && event.srcElement.parentElement.localName === "td")
    ) {
      let element = event.srcElement;
      if (
        event.srcElement.localName === "img" &&
        event.srcElement.currentSrc.includes("Fullscreen") &&
        event.srcElement.parentElement.localName === "td"
      ) {
        element = event.srcElement.parentElement;
      } else if (
        event.srcElement.className.includes("DrugAnnoTextPFA") &&
        event.srcElement.parentElement.localName === "td"
      ) {
        element = event.srcElement.parentElement;
      }

      if (element.id.includes("td-") && this.state.drug2ModalVisible === false) {
        if (this.state.guideline && isPageForAge(this.state.guideline.GLID)) {
          let elementID = element.id;
          let singleTableID = elementID.substring(elementID.lastIndexOf("-"), 0).replace("td-", "");
          let singleTableRowColumn = parseInt(elementID.substring(elementID.lastIndexOf("-") + 1));

          let succeeded = this.generateModalTable(this.state.guideline, element, singleTableID, singleTableRowColumn);
          if (succeeded === undefined) {
            if (this.props.match.url === event.currentTarget.location.pathname) {
              this.toggleDrugModal(true);
            }
          }
        } else {
          let succeeded = this.generateModalTable(this.state.guideline, element, null, null);
          if (succeeded === undefined) {
            if (this.props.match.url === event.currentTarget.location.pathname) {
              this.toggleDrugModal(true);
            }
          }
        }
      }
    }

    if (event.srcElement.localName === "button" && event.srcElement.classList.contains("ACCEDrugButton")) {
      let succeeded = this.generateModalTable(this.state.guideline, event.srcElement, null, null);
      if (succeeded === undefined) {
        if (this.props.match.url === event.currentTarget.location.pathname) {
          this.toggleDrugModal(true);
          if (this.state.guidelineSummary && DataController.isDrug(this.state.guidelineSummary)) {
            try {
              let dosageTableTitle = event.srcElement.innerText;
              dosageTableTitle = dosageTableTitle.replace("Dosage table: ", "");
              RemoteDataController.logEvent("med_navigation", {
                name: "Dosage table opened",
                title: dosageTableTitle,
                glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
              });
            } catch (error) {
              console.log(error);
            }
          }
        }
      }
    }

    if (event.srcElement.localName === "a") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        // console.log(event.srcElement);

        let href = event.srcElement.href;
        href = DataController.stripLocalLinks(href);

        if (href.includes("http")) {
          window.open(href, "_blank", "noreferrer");
          event.preventDefault();
        } else {
          if (href.includes("#")) {
            this.scrollToTable(event.srcElement);
            event.preventDefault();
          }
        }
      }
    }

    if (event.srcElement.localName === "link-note") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        this.scrollToTable(event.srcElement);
      }
    }

    if (event.srcElement.localName === "cm-link" || event.srcElement.localName === "link-cm") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        if (event.srcElement && event.srcElement.attributes && event.srcElement.attributes.length > 0) {
          let href = event.srcElement.attributes[0];

          if (event.srcElement.attributes.glid != null) {
            const GLID = event.srcElement.attributes.glid.value;
            const title = event.srcElement.textContent;
            let linkHref = null;
            if (event.srcElement.attributes.href != null) {
              linkHref = event.srcElement.attributes.href.value;
            }
            this.goToGuideline(GLID, linkHref, title);
          } else if (event.srcElement.attributes.cnid != null) {
            const cnid = event.srcElement.attributes.cnid.value;
            this.props.screenProps.navigateToClinicalNotice(
              cnid,
              this.props.match.params.tab,
              this.props.history,
              null,
              "Guideline"
            );
          } else if (href.value != null && href.value.includes("CLID")) {
            let GLID = href.value.substr(5);
            let title = event.srcElement.textContent;

            this.goToGuideline(GLID, null, title);
          } else if (href.value != null && href.value.substr(0, 1) === "-") {
            let GLID = href.value;
            let title = event.srcElement.textContent;

            this.goToGuideline(GLID, null, title);
          } else if (href.value && href.value.includes("http")) {
            if (!href.value.match(/^https?:\/\//i)) {
              let url = "https://" + href.value;
              window.open(url, "_blank", "noreferrer");
            } else {
              window.open(href.value, "_blank", "noreferrer");
            }
          } else if (href.value && href.value.includes("#")) {
            this.scrollToTable(event.srcElement);
            event.preventDefault();
          } else if (href.value != null) {
            if (!href.value.match(/^https?:\/\//i) && href.value.includes("tel:") === false) {
              let url = "https://" + href.value;
              window.open(url, "_blank", "noreferrer");
            } else {
              window.open(href.value, "_blank", "noreferrer");
            }
          }
        }
      }
    }

    if (event.srcElement.localName === "cm-abbrev-link") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        if (event.srcElement && event.srcElement.attributes && event.srcElement.attributes.length > 0) {
          let href = event.srcElement.attributes[0];
          if (href.value != null) {
            let abbreviation = this.state.abbreviations.find((abbreviation) => abbreviation.ID === href.value);
            if (abbreviation != null) {
              this.toggleAbbreviationPopover(true, event, abbreviation);
            }
          }
        }
      }
    }

    if (event.srcElement.localName === "link-webpage") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        if (event.srcElement && event.srcElement.attributes && event.srcElement.attributes.length > 0) {
          let href = event.srcElement.attributes[0];
          if (href.value != null) {
            window.open(href.value, "_blank", "noreferrer");
          }
        }
      }
    }

    if (event.srcElement.localName === "img" && event.srcElement.className === "img11") {
      if (this.props.match.url === event.currentTarget.location.pathname) {
        let imageTag = event.srcElement.outerHTML;
        this.toggleImageModal(true, imageTag);
      }
    }

    if (event.srcElement.className.includes("imageModalThumbnail")) {
      try {
        let index = parseInt(event.srcElement.id.replace("imageModalThumbnail-", ""));
        this.openReferenceCard(index);
      } catch (error) {}
    }
  };

  handleSelectionChangeEvent = (event: any) => {
    console.log("Selection:", document.getSelection()?.toString());
  };

  handlePageScroll = _.throttle(async () => {
    if (this.state.guidelineSummary != null) {
      let scrollElement = null;
      let ionContentElement = null;
      let shouldShowAgeBanner = false;

      // guideline page
      if (this.ionContent && this.ionContent.current) {
        scrollElement = await this.ionContent.current.getScrollElement();
        ionContentElement = this.ionContent.current;

        if (DataController.isPageForAge(this.state.guidelineSummary.GLID)) {
          if (scrollElement.scrollTop > 100) {
            shouldShowAgeBanner = true;
          }
        } else {
          let agePickerElements = this.ionContent.current.getElementsByClassName("guidelineShowForAgeContainer");
          if (agePickerElements != null && agePickerElements.length > 0) {
            let agePickerElement = agePickerElements[0];
            if (scrollElement != null) {
              // @ts-ignore
              if (scrollElement.scrollTop > agePickerElement.offsetTop + 80) {
                shouldShowAgeBanner = true;
              }
            }
          }
        }
      }

      if (ionContentElement) {
        if (shouldShowAgeBanner) {
          ionContentElement.classList.add("guidelineAgeBannerVisible");
        } else {
          ionContentElement.classList.remove("guidelineAgeBannerVisible");
        }
      }
    }
  }, 150);

  handleBackEvent = (event: any) => {
    if (isPlatform(window, "android")) {
      if (this.state.drugModalVisible) {
        this.setState({
          drugModalVisible: false,
          drugModalFiltered: false,
        });
      } else if (this.state.drug2ModalVisible) {
        this.setState({
          drug2ModalVisible: false,
          drug2ModalFiltered: false,
        });
      } else if (this.state.fontModalVisible) {
        this.setState({
          fontModalVisible: false,
        });
      } else if (this.state.bookmarkSuggestionModalVisible) {
        this.setState({
          bookmarkSuggestionModalVisible: false,
        });
      } else if (this.state.abbreviationPopoverVisible) {
        this.setState({
          abbreviationPopoverVisible: false,
        });
      } else if (this.state.imageModalVisible) {
        this.setState({
          imageModalVisible: false,
        });
      } else {
        try {
          this.props.history.goBack();
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  async goToGuideline(GLID: string, id: string | null, title: string) {
    try {
      let guidelineSummaries: IGuidelineSummary[] = this.props.screenProps.guidelineSummaries;
      let index = guidelineSummaries.findIndex((guidelineSummary) => guidelineSummary.GLID === GLID);
      let content: any = document.getElementsByTagName("ion-tab-bar")[0];

      if (index !== -1) {
        let guidelineSummary = guidelineSummaries[index];

        this.props.screenProps.updateGuidelineLastOpenedVersion(guidelineSummary);

        if (this.props.location) {
          // this.props.location.scrollPosition = 'test';
        }

        if (this.ionContent && this.ionContent.current) {
          let scrollElement = await this.ionContent.current.getScrollElement();

          let pageStateHistory = this.state.pageStateHistory.slice();
          let pageStateFound = false;
          for (let pageState of pageStateHistory) {
            if (pageState.glid === this.state.selectedGLID) {
              pageState.scrollPosition = scrollElement.scrollTop;
              pageState.openSections = this.getOpenSections();
              pageStateFound = true;
              break;
            }
          }
          if (pageStateFound === false) {
            pageStateHistory.push({
              glid: this.state.selectedGLID,
              openSections: this.getOpenSections(),
              scrollPosition: scrollElement.scrollTop,
            });
          }

          this.setState({ pageStateHistory: pageStateHistory });
        }

        this.setState({ drugModalVisible: false, drug2ModalVisible: false });

        let params: any = { time: Date.now() };
        if (id) {
          params.id = id;
        }

        if (GLID === this.state.guidelineSummary?.GLID) {
          if (id) {
            this.goToId(id);
          }
        } else {
          this.props.screenProps.navigateToGuideline(
            GLID,
            this.props.match.params.tab,
            this.props.history,
            params,
            "Guideline"
          );
        }
      } else {
        this.setAlertVisible(true, { GLID, title });
      }
    } catch (error) {
      console.log(error);
    }
  }

  resetCards() {
    try {
      const guideline = this.state.guideline;

      if (guideline == null) {
        return;
      }

      let finished = false;
      let i = 0;

      while (!finished) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
        ) as HTMLElement;
        let cardIcon: HTMLImageElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
        ) as HTMLImageElement;

        if (cardContent !== null) {
          if (
            cardContent.className.includes("quicklookContraCard") === false &&
            cardContent.className.includes("pageForAgeLeadingSection") === false
          ) {
            // cardContent.hidden = true;
            // if (cardIcon !== null) {
            //   cardIcon.src = this.props.screenProps.darkMode ? iconPlusDark : iconPlus;
            // }
            this.openSection(i, false);
          } else {
            // if (cardIcon != null) {
            //   cardIcon.src = this.props.screenProps.darkMode ? iconMinusDark : iconMinus;
            // }
            this.openSection(i, true);
          }
        } else {
          finished = true;
        }

        if (!finished) {
          i++;
        }
      }

      if (i === 1) {
        // only one section so it should be open by default
        this.openSection(0, true);
      }

      let updatesCardContent: HTMLElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}`
      ) as HTMLElement;
      let updatesCardIcon: HTMLImageElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}-icon`
      ) as HTMLImageElement;

      if (updatesCardContent !== null && updatesCardIcon !== null) {
        // updatesCardContent.hidden = true;
        // updatesCardIcon.src = this.props.screenProps.darkMode ? iconPlusDark : iconPlus;
        this.openSection(i + 1, false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleSearch(focusKeyboard: boolean) {
    this.setState({
      showSearch: !this.state.showSearch,
      searchText: "",
    });

    // if about to show search - focus keyboard if requested
    if (!this.state.showSearch && focusKeyboard) {
      setTimeout(() => {
        if (this.searchTextField.current) {
          this.searchTextField.current.setFocus();
        }
      }, 200);
    }
  }

  enterButtonClicked(event: any) {
    if (event.key === "Enter") {
      this.nextOccurence();
    }
  }

  clearSearch() {
    this.searchTextField.current?.setFocus();
    this.setState({ searchText: "" });
  }

  bookmarkButtonPressed() {
    if (this.state.guideline != null) {
      this.props.screenProps.saveBookmark(this.state.guideline.GLID, null, null, null, "guideline");
    }
  }

  textButtonPressed() {
    this.setState({
      textActive: !this.state.textActive,
    });
  }

  setAlertVisible(value: boolean, guideline?: any) {
    if (this.state.guideline != null) {
      let GLID = this.state.guideline.GLID;

      if (this.props.location.pathname === this.props.match.url) {
        if (this.props.location.pathname.includes(GLID)) {
          if (guideline) {
            this.setState({
              alertOpen: value,
              unavailable: guideline,
            });
          } else {
            this.setState({
              alertOpen: value,
            });
          }
        }
      }
    }
  }

  isBookmarked() {
    if (this.state.guideline) {
      let bookmark = _.find(this.props.screenProps.bookmarks, { GLID: this.state.guideline.GLID, type: "guideline" });
      return bookmark != null;
    } else {
      return false;
    }
  }

  openReferenceCard(imageIndex: number) {
    try {
      if (
        this.state.guidelineSummary &&
        this.state.guidelineSummary.images &&
        this.state.guidelineSummary.images.length > 0
      ) {
        let imageName = null;

        let referenceCardImageNames: string[] = [];
        if (this.state.referenceCard) {
          if (this.state.referenceCard.imageNames) {
            referenceCardImageNames = this.state.referenceCard.imageNames;
          } else if (this.state.referenceCard.imageName) {
            referenceCardImageNames = [this.state.referenceCard.imageName];
          }
        }

        if (referenceCardImageNames.length > 0) {
          for (let image of this.state.guidelineSummary.images) {
            if (image.imageName === referenceCardImageNames[imageIndex]) {
              imageName = image.imageName;
              this.setState({ currentReferenceCardIndex: imageIndex });
              break;
            }
          }
        }

        // fallback if no reference card image specified - use first image
        if (imageName == null) {
          imageName = this.state.guidelineSummary.images[0].imageName;
        }

        let imageTag = this.replaceImages(`<img src="${imageName}">`);
        this.toggleImageModal(true, imageTag);
      }
    } catch (error) {
      console.log(error);
    }
  }

  scrollToTable(button: HTMLElement) {
    let href: string = button.getAttribute("href") as string;
    href = href.substr(href.indexOf("#") + 1, href.length - (href.indexOf("#") + 1));
    let table = document.getElementById(href);

    try {
      if (table !== null) {
        if (table.localName === "p-left") {
          if (table.previousElementSibling !== null && table.previousElementSibling.localName === "img-100") {
            table = table.previousElementSibling as HTMLElement;
          }
        }
        let element = table;

        while (element.localName !== "ion-card-content") {
          if (element.parentElement !== null) {
            element = element.parentElement;
          }
        }

        this.openSectionIfClosed(element.id);
        table.scrollIntoView({ behavior: "smooth" });
      }
    } catch (error) {
      console.log(error);
    }
  }

  openSectionIfClosed(id: any) {
    let content: HTMLElement = document.getElementById(id) as HTMLElement;
    let icon: HTMLImageElement = document.getElementById(`${id}-icon`) as HTMLImageElement;

    if (content !== null && icon !== null) {
      if (content.hidden) {
        content.hidden = false;
        icon.src = this.props.screenProps.darkMode ? iconMinusDark : iconMinus;
      }
    }
  }

  headerClicked(i: any, event?: any) {
    this.toggleSection(i);
  }

  toggleSection(i: number) {
    const guideline = this.state.guideline;

    if (guideline == null) {
      return false;
    }

    let cardContent: HTMLElement = document.getElementById(
      `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
    ) as HTMLElement;
    let icon: HTMLImageElement = document.getElementById(
      `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
    ) as HTMLImageElement;

    if (cardContent !== null && icon !== null) {
      if (cardContent.hidden) {
        this.openSection(i, true);
      } else {
        cardContent.hidden = true;
        this.openSection(i, false);
      }
    }

    try {
      if (cardContent.hidden !== true) {
        if (this.state.guidelineSummary && DataController.isDrug(this.state.guidelineSummary)) {
          if (cardContent.parentElement && cardContent.parentElement.children.length > 1) {
            let cardTtitle = cardContent.parentElement.children[0].textContent;
            RemoteDataController.logEvent("med_navigation", {
              name: "Section Opened",
              section: cardTtitle,
              glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
            });
          }
        }
      }
    } catch (error) {}
  }

  openSection(i: number, shouldOpen: boolean) {
    const guideline = this.state.guideline;

    if (guideline == null) {
      return false;
    }

    let cardContent: HTMLElement = document.getElementById(
      `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
    ) as HTMLElement;
    let icon: HTMLImageElement = document.getElementById(
      `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
    ) as HTMLImageElement;

    if (cardContent !== null && icon !== null) {
      if (shouldOpen) {
        cardContent.hidden = false;
        icon.src = this.props.screenProps.darkMode ? iconMinusDark : iconMinus;
      } else {
        cardContent.hidden = true;
        icon.src = this.props.screenProps.darkMode ? iconPlusDark : iconPlus;
      }
    }

    if (shouldOpen && this.state.toggleSectionsText === "Expand all") {
      if (this.state.firstOpen === false) {
        this.setState({ toggleSectionsText: "Collapse all" });
      }
    } else {
      let openSections = this.getOpenSections();
      if (shouldOpen === false && (openSections.length === 0 || openSections[0] === 0)) {
        this.setState({ toggleSectionsText: "Expand all" });
      }
    }
  }

  async openAllSections() {
    try {
      const guideline = this.state.guideline;

      if (guideline == null) {
        return [];
      }

      let finished = false;
      let i = 0;

      while (!finished) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
        ) as HTMLElement;
        let cardIcon: HTMLImageElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
        ) as HTMLImageElement;

        if (cardContent !== null) {
          if (this.isSectionOpen(i) === false) {
            this.openSection(i, true);
          }
        } else {
          finished = true;
        }

        if (!finished) {
          i++;
        }
      }

      let updatesCardContent: HTMLElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}`
      ) as HTMLElement;
      let updatesCardIcon: HTMLImageElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}-icon`
      ) as HTMLImageElement;

      if (updatesCardContent !== null && updatesCardIcon !== null) {
        if (this.isSectionOpen(i + 1)) {
          this.openSection(i + 1, true);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  closeAllSections() {
    try {
      const guideline = this.state.guideline;

      if (guideline == null) {
        return [];
      }

      let finished = false;
      let i = 0;

      while (!finished) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
        ) as HTMLElement;
        let cardIcon: HTMLImageElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
        ) as HTMLImageElement;

        if (cardContent !== null) {
          if (this.isSectionOpen(i)) {
            this.openSection(i, false);
          }
        } else {
          finished = true;
        }

        if (!finished) {
          i++;
        }
      }

      let updatesCardContent: HTMLElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}`
      ) as HTMLElement;
      let updatesCardIcon: HTMLImageElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}-icon`
      ) as HTMLImageElement;

      if (updatesCardContent !== null && updatesCardIcon !== null) {
        if (this.isSectionOpen(i + 1)) {
          this.openSection(i + 1, false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  toggleAllSections() {
    if (this.state.toggleSectionsText === "Expand all") {
      this.openAllSections();
    } else {
      this.closeAllSections();
    }
  }

  getOpenSections(): number[] {
    let openSections = [];

    try {
      const guideline = this.state.guideline;

      if (guideline == null) {
        return [];
      }

      let finished = false;
      let i = 0;

      while (!finished) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
        ) as HTMLElement;
        let cardIcon: HTMLImageElement = document.getElementById(
          `${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`
        ) as HTMLImageElement;

        if (cardContent !== null) {
          if (this.isSectionOpen(i)) {
            openSections.push(i);
          }
        } else {
          finished = true;
        }

        if (!finished) {
          i++;
        }
      }

      let updatesCardContent: HTMLElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}`
      ) as HTMLElement;
      let updatesCardIcon: HTMLImageElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i + 1}-icon`
      ) as HTMLImageElement;

      if (updatesCardContent !== null && updatesCardIcon !== null) {
        if (this.isSectionOpen(i + 1)) {
          openSections.push(i + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
    return openSections;
  }

  getSectionsCount(): number {
    let finished = false;
    let i = 0;

    const guideline = this.state.guideline;
    if (guideline == null) {
      return 0;
    }

    while (!finished) {
      let cardContent: HTMLElement = document.getElementById(
        `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
      ) as HTMLElement;
      if (cardContent == null) {
        finished = true;
      }
      if (!finished) {
        i++;
      }
    }
    return i;
  }

  isSectionOpen(i: any) {
    const guideline = this.state.guideline;
    if (guideline == null) {
      return false;
    }

    let content: HTMLElement = document.getElementById(
      `${this.props.match.params.tab}-${guideline.GLID}-content-${i}`
    ) as HTMLElement;

    if (content !== null) {
      if (content.hidden) {
        return false;
      } else {
        return true;
      }
    }

    return false;
  }

  findSectionsWithSearchHighlights() {}

  generateDrugTable(
    html: any,
    table: any,
    GLID: any,
    age: any,
    singleTableID: string | null,
    singleTableRowColumn: number | null
  ) {
    const h: any = parser.parseFromString(html, "text/html");
    const tables = h.getElementsByTagName("AACETableInsertPosition");

    let trust = this.props.screenProps.trust;

    var reverse = isPageForAge(GLID) ? true : false;

    if (singleTableID != null && singleTableRowColumn != null) {
      var specifiedDrugTable = table.find((aTable: any) => aTable.ID === singleTableID);

      if (specifiedDrugTable) {
        var specifiedDrugTableCopy = _.cloneDeep(specifiedDrugTable);
        specifiedDrugTableCopy.rowColData.splice(0, specifiedDrugTableCopy.rowColData.length);
        specifiedDrugTableCopy.rowColData.push(specifiedDrugTable.rowColData[0]);
        specifiedDrugTableCopy.rowColData.push(specifiedDrugTable.rowColData[singleTableRowColumn]);

        // specific handling for SWAST Sabutamol in Page for Age - adds next row of annotation data when clicking on Salbutamol row
        try {
          let drugColumnData = specifiedDrugTable.rowColData[singleTableRowColumn];
          if (
            trust === "SWAST" &&
            drugColumnData.columns &&
            drugColumnData.columns.length > 2 &&
            drugColumnData.columns[2].text === "Salbutamol"
          ) {
            specifiedDrugTableCopy.rowColData.push(specifiedDrugTable.rowColData[singleTableRowColumn + 1]);
          }
        } catch (error) {
          console.log(error);
        }

        reverse = false;

        let result = TableHandler.getHTMLForTable(
          specifiedDrugTableCopy,
          GLID,
          age,
          reverse,
          trust,
          this.props.screenProps.annotations
        );
        if (result !== undefined) {
          const tableElement: HTMLElement = tables[0];
          if (this.props.screenProps.debugMode) {
            result += `<pre class="debugBox">${JSON.stringify(specifiedDrugTableCopy.rowColData, null, 2)}</pre>`;
          }
          tableElement.innerHTML = result;
        }
      } else {
        let result = TableHandler.getHTMLForTable(
          specifiedDrugTable,
          GLID,
          age,
          reverse,
          trust,
          this.props.screenProps.annotations
        );
        if (result !== undefined) {
          const tableElement: HTMLElement = tables[0];
          if (this.props.screenProps.debugMode) {
            result += `<pre class="debugBox">${JSON.stringify(specifiedDrugTable.rowColData, null, 2)}</pre>`;
          }
          tableElement.innerHTML = result;
        }
      }
    } else {
      for (let i = 0; i < tables.length; i++) {
        const tableElement: HTMLElement = tables[i];

        for (let drugTableIndex = 0; drugTableIndex < table.length; drugTableIndex++) {
          let drugTable = table[drugTableIndex];

          if (drugTable.ID === tableElement.id) {
            let trust = this.props.screenProps.trust;

            let result = TableHandler.getHTMLForTable(
              table[drugTableIndex],
              GLID,
              age,
              reverse,
              trust,
              this.props.screenProps.annotations
            );

            if (result !== undefined) {
              if (this.props.screenProps.debugMode) {
                result += `<pre class="debugBox">${JSON.stringify(table[drugTableIndex].rowColData, null, 2)}</pre>`;
              }
              tableElement.innerHTML = result;
            }
          }
        }
      }
    }

    let freezeFirstColumnInMedTablesClass =
      this.props.screenProps.freezeFirstDrugColumn && this.props.features.includes("freezeFirstColumnMedTable")
        ? "stickyDrugTable"
        : "";

    return `<div class="${freezeFirstColumnInMedTablesClass}">${h.firstChild.lastChild.innerHTML}</div>`;
  }

  generateModalTable(guideline: any, element: any, singleTableID: string | null, singleTableRowColumn: number | null) {
    try {
      let GLID = guideline.GLID;
      let selectedTable = null;

      if ((this.state.drugModalFiltered || this.state.drug2ModalFiltered) && singleTableID != null) {
        // already filtered table so don't generate again
        return false;
      }

      for (let section of guideline.sections) {
        if (section.TableAndBoxes !== undefined) {
          let table = section.TableAndBoxes.filter((table: any) => element.id.includes(table.ID));
          if (table != null && table.length > 0) {
            selectedTable = table;
          }
        }
      }

      if (selectedTable == null) {
        return true;
      }

      let age;

      try {
        let range = element.getAttribute("value");
        age = DataController.getAgesObjects().find((object: any) => object.range === range);
      } catch (error) {
        console.log(error);
      }

      let html = "";

      try {
        if (singleTableRowColumn) {
          var specifiedDrugTable = selectedTable.find((aTable: any) => aTable.ID === singleTableID);
          if (specifiedDrugTable && specifiedDrugTable.rowColData) {
            let specifiedDrugTableColumn = specifiedDrugTable.rowColData[singleTableRowColumn];
            let ageText = specifiedDrugTableColumn.columns[1].text;
            let ageTextHtml = `<div class='ACCETableAgeText'>Showing for: <span class='ACCETableAgeTextBold'>${ageText}</span></div>`;
            html += ageTextHtml;
          }
        } else {
          if (this.hasAgePicker() && this.props.screenProps.patientAge.name !== "All") {
            let ageTextHtml = `<div class='ACCETableAgeText'>Showing for: <span class='ACCETableAgeTextBold'>${this.props.screenProps.patientAge.name}</span></div>`;
            html += ageTextHtml;
          }
        }
      } catch (error) {
        console.log(error);
      }

      html += `<AACETableInsertPosition id=${selectedTable[0].ID} bind-html-compile="getAACETable('${selectedTable[0].ID}')"></AACETableInsertPosition>`;

      if (age === undefined) {
        html = this.generateDrugTable(
          html,
          selectedTable,
          GLID,
          this.props.screenProps.patientAge,
          singleTableID,
          singleTableRowColumn
        );
      } else {
        html = this.generateDrugTable(html, selectedTable, GLID, age, singleTableID, singleTableRowColumn);
      }

      if (this.state.drugModalVisible) {
        // drug modal already visible so open second one
        this.setState({
          drug2ModalTable: html,
        });

        if (singleTableID) {
          this.setState({
            drug2ModalFiltered: true,
          });
        }
      } else {
        this.setState({
          drugModalTable: html,
        });

        if (singleTableID) {
          this.setState({
            drugModalFiltered: true,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  generateTable(html: any) {
    const h: any = parser.parseFromString(html, "text/html");
    const tables = h.getElementsByTagName("table");

    for (let i = 0; i < tables.length; i++) {
      const table: HTMLElement = tables[i];
      let widths = table.getAttribute("columnwidths");
      let result = "";
      let widthsArray: any = [];

      if (widths !== null) {
        widthsArray = widths.split(" ");
      }

      for (let j = 0; j < widthsArray.length; j++) {
        result += `<col width="${widthsArray[j]}%">`;
      }

      const colGroup = document.createElement("colgroup");
      colGroup.innerHTML = result;
      const body = table.querySelector("tbody");
      table.insertBefore(colGroup, body);
    }

    return h.firstChild.lastChild.innerHTML;
  }

  generateTrustSections(guideline: any) {
    var trust = guideline.trust;

    var errorList: any = [];
    const aTrustRender = new TrustRender(errorList);
    var content = aTrustRender.htmlFromJson(guideline, trust);

    var test = "";

    const result: any = [];

    let frontHtml = this.replaceImages(content.frontHtml);
    frontHtml = DataController.addHighlight(frontHtml, this.state.searchText);

    // add front content
    result.push(
      <div
        key={`${this.props.match.params.tab}-${guideline.GLID}-front`}
        style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
        dangerouslySetInnerHTML={{ __html: frontHtml }}
      />
    );

    // add sections
    for (let i = 0; i < content.sections.length; i++) {
      const section = content.sections[i];
      let html = section.sectionHTML;
      let titleHtml = section.SectionTitle;

      if (this.state.searchText.length > 1) {
        html = DataController.addHighlight(html, this.state.searchText);
        titleHtml = DataController.addHighlight(titleHtml, this.state.searchText);
      }

      html = this.addSubSubsections(html);
      html = this.replaceImages(html);

      // html = html.replace(/cm-link/g, 'a');
      html = html.replace(/nref/g, "a");

      if (html.includes("<table")) {
        html = html.replace(
          /<table/g,
          '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; overflow-y: hidden;"><table'
        );
        html = html.replace(/<\/table>/g, "</table></div>");
      }

      result.push(
        <IonCard mode="md" className="card sectionCard" key={`${this.props.match.params.tab}-${guideline.GLID}-${i}`}>
          <IonCardHeader className="GLHeader" onClick={(event) => this.headerClicked(i, event)}>
            <IonCardTitle className="greenTitle" style={{ fontSize: this.fontSize(18) }}>
              <div dangerouslySetInnerHTML={{ __html: titleHtml }} />
            </IonCardTitle>
            <img
              id={`${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`}
              src={this.props.screenProps.darkMode ? iconPlusDark : iconPlus}
              alt=""
              style={{
                position: "absolute",
                height: 44,
                width: 44,
                top: 0,
                bottom: 0,
                right: 6,
                margin: "auto",
              }}
            />
          </IonCardHeader>
          <IonCardContent
            mode="md"
            className="guidelineCardContent trustGuidelineCardContent text AACE-Section-body"
            style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
            id={`${this.props.match.params.tab}-${guideline.GLID}-content-${i}`}
          >
            {this.props.screenProps.showTextToSpeech ? (
              <div className="guidelinePlaySectionContainer" onClick={(event) => this.readGuideline(i)}>
                <div className="guidelinePlaySectionButton" onClick={(event) => this.readGuideline(i)}>
                  <img alt="" src={this.props.screenProps.darkMode ? iconPlayDark : iconPlay} className="icon-32" />
                  Play section
                </div>
              </div>
            ) : null}

            <div dangerouslySetInnerHTML={{ __html: html }} />
          </IonCardContent>
        </IonCard>
      );
    }

    let endHtml = this.replaceImages(content.endHtml);
    endHtml = DataController.addHighlight(endHtml, this.state.searchText);

    // add end content
    result.push(
      <div
        key={`${this.props.match.params.tab}-${guideline.GLID}-end`}
        style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
        dangerouslySetInnerHTML={{ __html: this.replaceImages(endHtml) }}
      />
    );

    return result;
  }

  generateSections(guideline: any) {
    // is not called every render - if adding a change that requires state - it should be included in componentDidUpdate
    if (guideline == null) {
      return [];
    }

    // trust guidelines are formatted slightly differently rather than JRCALC - so generate them differently
    if (guideline.trust && guideline.sections == null) {
      return this.generateTrustSections(guideline);
    }

    let annotations = this.state.guidelineSummary?.annotations;

    // hide sections if Hide JRCALC is set (and annotation isn't for a particular section)
    if (annotations) {
      for (let annotation of annotations) {
        let annotationIsForDrugTable = DataController.isAnnotationForDrugTable(annotation, guideline);

        if (annotationIsForDrugTable === false) {
          let annotationReferenceParts = annotation.Reference.split(" - ");
          if (annotationReferenceParts.length === 2) {
            if (annotation["Hide JRCALC?"]) {
              return [];
            }
          }
        }
      }
    }

    const sections = guideline && guideline.sections;
    const result = [];

    if (guideline.publ_guideline_FrontMatterEndMatter) {
      let frontMatterHtml = '<div class="SWASTFrontmatter">';

      if (guideline.publ_guideline_clinical_publication_category) {
        frontMatterHtml += "<div class=SWASTSUBHead>Clinical Publication Category";
        var category = "SWAST-GREEN";

        if (guideline.publ_guideline_clinical_publication_category.toUpperCase().indexOf("GREEN") != -1) {
          category = "SWAST-GREEN";
        }
        if (guideline.publ_guideline_clinical_publication_category.toUpperCase().indexOf("AMBER") != -1) {
          category = "SWAST-AMBER";
        }
        if (guideline.publ_guideline_clinical_publication_category.toUpperCase().indexOf("MANDATORY") != -1) {
          category = "SWAST-MANDATORY";
        }

        frontMatterHtml +=
          "<div class=" + category + ">" + guideline.publ_guideline_clinical_publication_category + "</div>";
        frontMatterHtml += "</div>";
      }

      if (guideline.publ_guideline_type) {
        frontMatterHtml += "<div class=SWASTRefNo><b>Guideline Type:</b> " + guideline.publ_guideline_type + "</div>";
      }
      if (guideline.publ_guideline_staff_grades) {
        frontMatterHtml += "<div class=SWASTRefNo><b>Staff Grades: </b>";
        frontMatterHtml += guideline.publ_guideline_staff_grades + "</div>";
      }
      if (guideline.publ_guideline_supplements_replaces) {
        frontMatterHtml +=
          "<div class=SWASTRefNo><b>Supplements / replaces:</b> " +
          guideline.publ_guideline_supplements_replaces +
          "</div>";
      }
      if (guideline.publ_guideline_no_ref) {
        frontMatterHtml += "<div class=SWASTRefNo><b>Reference No:</b> " + guideline.publ_guideline_no_ref + "</div>";
      }
      if (guideline.publ_guideline_legal_category) {
        frontMatterHtml +=
          "<div class=SWASTRefNo><b>Legal category:</b> " + guideline.publ_guideline_legal_category + "</div>";
      }
      if (guideline.publ_guideline_target_audience) {
        frontMatterHtml +=
          "<div class=SWASTRefNo><b>Target Audience:</b> " + guideline.publ_guideline_target_audience + "</div>";
      }
      if (guideline.publ_keyword_taxonomy) {
        frontMatterHtml += "<div class=SWASTRefNo><b>Keywords:</b> " + guideline.publ_keyword_taxonomy + "</div>";
      }

      frontMatterHtml += "</div>";

      result.push(
        <div
          style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
          dangerouslySetInnerHTML={{ __html: frontMatterHtml }}
        />
      );
    }

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      let html = section.sectionHTML;
      let titleHtml = section.SectionTitle;

      let sectionHasAnnotation = false;

      if (annotations) {
        let userTrust = this.props.screenProps.trust;

        for (let annotation of annotations) {
          let annotationReferenceParts = annotation.Reference.split(" - ");
          if (annotationReferenceParts.length > 2 && annotation["note (html)"]) {
            if (section.SectionTitle === annotationReferenceParts[2].trim()) {
              sectionHasAnnotation = true;

              var aNote = annotation["note (html)"];
              let noteHTML =
                "<div class=" +
                userTrust.toLowerCase() +
                'Note><div class="' +
                userTrust +
                'NoteBox"><div class=' +
                userTrust +
                "NoteTitle>" +
                DataController.getTrustDisplayName(userTrust) +
                ' Additional Guidance</div><div class="trustNoteData ' +
                userTrust +
                'NoteData">' +
                aNote +
                "</div></div></div>";

              if (titleHtml.indexOf("<SectionTrust") === -1)
                titleHtml =
                  titleHtml +
                  "<SectionTrust" +
                  userTrust +
                  ">" +
                  DataController.getTrustDisplayName(userTrust) +
                  " AG</SectionTrust" +
                  userTrust +
                  ">";
              if (annotation["Hide JRCALC?"] === "true") {
                html = noteHTML;
              } else {
                if (aNote.indexOf("ACCEDrugTablePFAWide") !== -1) {
                  console.log("ACCEDrugTablePFAWide found in Note");
                  aNote = aNote
                    .split('<table class="ACCEDrugTablePFAWide">')
                    .join(
                      '<ion-scroll has-bouncing="false" style="" direction="x"><table class="ACCEDrugTablePFAWide">'
                    );
                  aNote = aNote.split("</table>").join("</table></ion-scroll>");
                }

                html = noteHTML + html;
              }
            }
          } else {
            // annotation reference might be for a drug - see if there is a section including it
            let sectionIsForAnnotation = DataController.isAnnotationForDrugTable(annotation, guideline, section);

            if (sectionIsForAnnotation) {
              if (titleHtml.indexOf("<SectionTrust") === -1) {
                titleHtml =
                  titleHtml +
                  "<SectionTrust" +
                  userTrust +
                  ">" +
                  DataController.getTrustDisplayName(userTrust) +
                  " AG</SectionTrust" +
                  userTrust +
                  ">";
              }
            }
          }
        }
      }

      html = this.replaceImages(html);
      html = this.addSubSubsections(html);

      html = html.replace(".png", ".jpg");
      html = html.replace(/<index-entry1([^>]*)>([\s\S]*?)<\/index-entry1>/g, "");

      html = html.replace(/<nref/g, "<a class='nref'");
      html = html.replace(/<\/nref>/g, "</a>");

      //

      if (html.includes("<table")) {
        html = this.generateTable(html);
        html = html.replace(
          /<table/g,
          '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; overflow-y: hidden;"><table'
        );
        html = html.replace(/<\/table>/g, "</table></div>");
      }

      if (html.includes("AACETableInsertPosition") || html.includes("aacetableinsertposition")) {
        let tables = TableHandler.getDrugTable(guideline);
        html = this.generateDrugTable(html, tables, guideline.GLID, this.props.screenProps.patientAge, null, null);
      }

      if (this.state.searchText.length > 1) {
        html = DataController.addHighlight(html, this.state.searchText);
        titleHtml = DataController.addHighlight(titleHtml, this.state.searchText);
      }

      if (section.SectionTitle === "LeadingSection") {
        if (isPageForAge(guideline.GLID)) {
          let pageForAgeLeadingHtml = this.getPageForAgeLeadingSection(html);

          if (pageForAgeLeadingHtml != null && pageForAgeLeadingHtml !== "") {
            html = pageForAgeLeadingHtml;
          }
        }

        result.push(
          <div
            key={`${this.props.match.params.tab}-${guideline.GLID}-${i}`}
            id={`${this.props.match.params.tab}-${guideline.GLID}-content-${i}`}
            className="pageForAgeLeadingSection"
            style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
            dangerouslySetInnerHTML={{ __html: html }}
          />
        );
      } else {
        result.push(
          <IonCard
            mode="md"
            id={section.SectionID}
            className="card sectionCard"
            key={`${this.props.match.params.tab}-${guideline.GLID}-${i}`}
          >
            <IonCardHeader className="GLHeader" onClick={(event) => this.headerClicked(i, event)}>
              <IonCardTitle className="greenTitle" style={{ fontSize: this.fontSize(18) }}>
                <div dangerouslySetInnerHTML={{ __html: titleHtml }} />
              </IonCardTitle>
              <img
                id={`${this.props.match.params.tab}-${guideline.GLID}-content-${i}-icon`}
                src={this.props.screenProps.darkMode ? iconPlusDark : iconPlus}
                alt=""
                style={{
                  position: "absolute",
                  height: 44,
                  width: 44,
                  top: 0,
                  bottom: 0,
                  right: 6,
                  margin: "auto",
                }}
              />
            </IonCardHeader>
            <IonCardContent
              mode="md"
              className="guidelineCardContent AACE-Section-body text"
              style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
              id={`${this.props.match.params.tab}-${guideline.GLID}-content-${i}`}
            >
              {this.props.screenProps.showTextToSpeech ? (
                <div className="guidelinePlaySectionContainer" onClick={(event) => this.readGuideline(i)}>
                  <div className="guidelinePlaySectionButton">
                    <img alt="" src={this.props.screenProps.darkMode ? iconPlayDark : iconPlay} className="icon-32" />
                    Play section
                  </div>
                </div>
              ) : null}

              <div dangerouslySetInnerHTML={{ __html: html }} />
            </IonCardContent>
          </IonCard>
        );
      }
    }

    if (guideline.publ_guideline_FrontMatterEndMatter) {
      let endMatterHtml = '<div class="SWASTEndmatter">';

      if (guideline.publ_guideline_approved_by) {
        endMatterHtml +=
          '<div class="SWASTRefNo"><b>Approved by:</b> ' + guideline.publ_guideline_approved_by + "</div>";
      }
      if (guideline.publ_guideline_written_by) {
        endMatterHtml += '<div class="SWASTRefNo"><b>Written by:</b> ' + guideline.publ_guideline_written_by + "</div>";
      }
      if (guideline.publ_guideline_version) {
        endMatterHtml += '<div class="SWASTRefNo"><b>Version:</b> ' + guideline.publ_guideline_version + "</div>";
      }
      if (guideline.publ_guideline_date_issued) {
        endMatterHtml +=
          '<div class="SWASTRefNo"><b>Date issued:</b> ' +
          this.formatDate(guideline.publ_guideline_date_issued) +
          "</div>";
      }
      if (guideline.publ_guideline_date_review) {
        endMatterHtml +=
          '<div class="SWASTRefNo"><b>Review date:</b> ' +
          this.formatDate(guideline.publ_guideline_date_review) +
          "</div>";
      }
      if (guideline.publ_guideline_date_expiry) {
        endMatterHtml +=
          '<div class="SWASTRefNo"><b>Expiry date:</b> ' +
          this.formatDate(guideline.publ_guideline_date_expiry) +
          "</div>";
      }
      if (guideline.publ_guideline_date_approved) {
        endMatterHtml +=
          "<div class=SWASTRefNo><b>Approval date:</b> " +
          this.formatDate(guideline.publ_guideline_date_approved) +
          "</div>";
      }
      if (guideline.publ_guideline_directorate) {
        endMatterHtml += "<div class=SWASTRefNo><b>Directorate:</b> " + guideline.publ_guideline_directorate + "</div>";
      }

      endMatterHtml += "</div>";

      result.push(
        <div
          style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
          dangerouslySetInnerHTML={{ __html: endMatterHtml }}
        />
      );
    }

    return result;
  }

  formatDate(date: number | string) {
    try {
      // reverse date so it's in dd-mm-yyyy format
      let newDate = new Date(date);
      let dateText = format(newDate, "dd-MM-yyyy");
      return dateText;
    } catch (error) {
      return date;
    }
  }

  getPageForAgeLeadingSection(html: string) {
    let pageForAgeHtml = html;

    try {
      if (html.includes("JRCALCWhiteTable")) {
        const whiteTableHtml: Document = parser.parseFromString(html, "text/html");
        let whiteTables = whiteTableHtml.getElementsByTagName("table");

        let vitalSignsHtml = "";
        let airwayHtml = "";
        let defibrillationHtml = "";

        let vitalSignsTableOuterHtml = whiteTableHtml.getElementsByTagName("table")[0].outerHTML;
        let airwayTableOuterHtml = whiteTableHtml.getElementsByTagName("table")[1].outerHTML;
        let defibbrilationTableOuterHtml = whiteTableHtml.getElementsByTagName("table")[2].outerHTML;

        for (let whiteTableIndex = 0; whiteTableIndex < whiteTables.length; whiteTableIndex++) {
          let whiteTable: any | null = whiteTables.item(whiteTableIndex);

          if (whiteTable != null && whiteTable.innerText != null) {
            // VITAL SIGNS
            if (whiteTableIndex === 0) {
              let tables = whiteTable.getElementsByClassName("img-100");

              for (let tableIndex = 0; tableIndex < tables.length; tableIndex++) {
                let table = tables.item(tableIndex);

                if (table != null) {
                  let vitalSignElements = table.children;

                  if (vitalSignElements.length === 3) {
                    let vitalSignImageHtml: any = vitalSignElements.item(0);
                    let vitalSignLabel: any = vitalSignElements.item(1);
                    let vitalSignValue: any = vitalSignElements.item(2);

                    if (vitalSignImageHtml != null && vitalSignLabel != null && vitalSignValue != null) {
                      vitalSignsHtml += `
                      <div class='pageForAgeLeadingBoxRow'>
                        <div class='pageForAgeLeadingBoxImage'>
                          ${vitalSignImageHtml.outerHTML}
                        </div>
                        <div class='pageForAgeLeadingBoxTextContainer'>
                          <div class='pageForAgeLeadingBoxLabel'>${vitalSignLabel.innerText}</div>
                          <div class='pageForAgeLeadingBoxValue'>${vitalSignValue.innerText}</div>
                        </div>
                      </div>
                    `;
                    }
                  }
                }
              }

              vitalSignsHtml += "</div>";
            }

            // AIRWAY SIZE BY TYPE
            if (whiteTableIndex === 1) {
              airwayHtml += `
            <div class='pageForAgeLeadingBoxContainer'>`;

              let tables = whiteTable.getElementsByTagName("tr");

              if (tables.length === 2) {
                let rowLabels = tables.item(0);
                let rowValues = tables.item(1);

                if (rowLabels != null && rowValues != null) {
                  for (let rowIndex = 0; rowIndex < rowLabels.children.length; rowIndex++) {
                    let rowLabel: any = rowLabels.children.item(rowIndex);
                    let rowValue: any = rowValues.children.item(rowIndex);

                    if (rowLabel != null && rowValue != null) {
                      airwayHtml += `
                      <div class='pageForAgeLeadingBoxRow'>
                        <div class='pageForAgeLeadingBoxTextContainer'>
                          <div class='pageForAgeLeadingBoxLabel'>${rowLabel.innerText}</div>
                          <div class='pageForAgeLeadingBoxValue'>${rowValue.innerText}</div>
                        </div>
                      </div>
                    `;
                    }
                  }
                }
              }

              airwayHtml += "</div>";
            }

            // DEFIBRILLATION - CARDIAC ARREST
            if (whiteTableIndex === 2) {
              defibrillationHtml += `
            <div class='pageForAgeLeadingBoxContainer'>`;

              let tables = whiteTable.getElementsByTagName("tr");

              if (tables.length === 2) {
                let rowLabels = tables.item(0);
                let rowValues = tables.item(1);

                if (rowLabels != null && rowValues != null) {
                  for (let rowIndex = 0; rowIndex < rowLabels.children.length; rowIndex++) {
                    let rowLabel: any = rowLabels.children.item(rowIndex);
                    let rowValue: any = rowValues.children.item(rowIndex);

                    if (rowLabel != null && rowValue != null) {
                      defibrillationHtml += `
                      <div class='pageForAgeLeadingBoxRow'>
                        <div class='pageForAgeLeadingBoxTextContainer'>
                          <div class='pageForAgeLeadingBoxLabel'>${rowLabel.innerText}</div>
                          <div class='pageForAgeLeadingBoxValue'>${rowValue.innerText}</div>
                        </div>
                      </div>
                    `;
                    }
                  }
                }
              }

              defibrillationHtml += "</div>";
            }
          }
        }

        pageForAgeHtml = pageForAgeHtml.replace(vitalSignsTableOuterHtml, vitalSignsHtml);
        pageForAgeHtml = pageForAgeHtml.replace(airwayTableOuterHtml, airwayHtml);
        pageForAgeHtml = pageForAgeHtml.replace(defibbrilationTableOuterHtml, defibrillationHtml);
      }

      pageForAgeHtml = DataController.addHighlight(pageForAgeHtml, this.state.searchText);
    } catch (error) {
      console.log(error);
    }

    return pageForAgeHtml;
  }

  getQuicklook(guideline: any) {
    if (guideline == null || DataController.isPageForAge(guideline.GLID)) {
      return;
    }

    let sections = guideline.sections;
    if (sections == null) {
      sections = [];
    }

    const quicklook = sections.filter((section: any) => section.QuickLook === "Yes");
    const contra = sections.filter((section: any) => section.SectionTitle === "Contra-indications")[0];
    let drugTables = TableHandler.getDrugTable(guideline);
    let contraDiv;
    let html = "";

    if (contra !== undefined) {
      let contraHtml = contra.sectionHTML;
      let contraTitle = contra.SectionTitle;
      contraHtml = contraHtml.replace(/<index-entry1([^>]*)>([\s\S]*?)<\/index-entry1>/g, "");

      if (this.state.searchText.length > 1) {
        contraHtml = DataController.addHighlight(contraHtml, this.state.searchText);
        contraTitle = DataController.addHighlight(contraTitle, this.state.searchText);
      }

      contraDiv = (
        <IonCard className="card quicklookCard" mode="md" key={sections.length}>
          <IonCardHeader className="GLHeader" onClick={() => this.headerClicked(sections.length)}>
            <IonCardTitle className="greenTitle" style={{ fontSize: this.fontSize(18) }}>
              <div dangerouslySetInnerHTML={{ __html: contraTitle }} />
            </IonCardTitle>
            <img
              id={`${this.props.match.params.tab}-${guideline.GLID}-content-${sections.length}-icon`}
              src={this.props.screenProps.darkMode ? iconPlusDark : iconPlus}
              alt=""
              style={{
                position: "absolute",
                height: 44,
                width: 44,
                top: 0,
                bottom: 0,
                right: 6,
                margin: "auto",
              }}
            />
          </IonCardHeader>
          <IonCardContent
            mode="md"
            color="#FFFFFF"
            className="guidelineCardContent quicklookContraCard AACE-Section-body text"
            style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
            id={`${this.props.match.params.tab}-${guideline.GLID}-content-${sections.length}`}
          >
            <div dangerouslySetInnerHTML={{ __html: contraHtml }} />
          </IonCardContent>
        </IonCard>
      );
    }

    if (quicklook.length > 0) {
      let quicklookHtml = quicklook[0].sectionHTML;
      quicklookHtml = quicklookHtml.replace(/<index-entry1([^>]*)>([\s\S]*?)<\/index-entry1>/g, "");

      quicklookHtml = this.replaceImages(quicklookHtml);
      // quicklookHtml = quicklookHtml.replace(/src="/g, 'class="img11" src="/assets/img/');

      // if (_.findIndex(this.props.screenProps.images, ((_image: any) => _image.name.includes(this.state.guideline?.GLID))) !== -1) {
      //   let images = this.props.screenProps.images.filter((_image: any) => _image.name.includes(this.state.guideline?.GLID));

      //   for (let i = 0; i < images.length; i++) {
      //     let image = images[i];
      //     quicklookHtml = quicklookHtml.replace(`src="/assets/img/${image.name}"`, `src="${image.data}"`);
      //   }
      // }

      // quicklookHtml = quicklookHtml.replace(".png", ".jpg");

      if (this.state.searchText.length > 1) {
        quicklookHtml = DataController.addHighlight(quicklookHtml, this.state.searchText);
      }

      if (drugTables !== undefined && drugTables.length === 0) {
        return (
          <div className="AACEQuickLookDiv noMargin">
            {contraDiv !== undefined ? contraDiv : null}
            <div
              style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
              dangerouslySetInnerHTML={{ __html: quicklookHtml }}
            />
          </div>
        );
      }

      html += quicklookHtml;
    }

    if (drugTables !== undefined && drugTables.length > 0) {
      html += '<div class="ACCEDrugButtons padding-sides">';

      if (drugTables.length > 0) {
        for (let i = 0; i < drugTables.length; i++) {
          const table = drugTables[i];

          if (TableHandler.doesTableHaveAnyColumns(table.rowColData, this.props.screenProps.annotations)) {
            if (table.cpg_drug_short_info) {
              html += `<button id=button_${table.ID} style="font-size: ${this.fontSize(
                16
              )} !important;" class="ACCEDrugButton"> Dosage table: ${table.cpg_drug_short_info}</button>`;
            } else {
              html += `<button id=button_${table.ID} style="font-size: ${this.fontSize(
                16
              )} !important;" class="ACCEDrugButton"> Dosage table: ${i} (text TBC)</button>`;
            }
          }
        }
        html += "</div>";
      }

      if (this.state.searchText.length > 1) {
        html = DataController.addHighlight(html, this.state.searchText);
      }

      return (
        <div className="AACEQuickLookDiv">
          {contraDiv !== undefined ? contraDiv : null}
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      );
    }

    return contraDiv !== undefined ? <div className="AACEQuickLookDiv">{contraDiv}</div> : null;
  }

  takeParaPassQuiz() {
    if (this.state.guidelineSummary) {
      RemoteDataController.logEvent("guideline_quiz_clicked", {
        glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
        abTestingVersion: this.props.screenProps.abTestingVersion,
      });
      this.props.screenProps.takeParaPassQuiz(this.state.guidelineSummary.GLID);
    }
  }

  takeParaPassPGDQuiz() {
    if (this.state.guidelineSummary) {
      RemoteDataController.logEvent("take_pgd_quiz", {
        glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
      });
      this.props.screenProps.takeParaPassPGDQuiz(this.state.guidelineSummary.GLID);
    }
  }

  async acknowledgePGD() {
    if (this.state.guidelineSummary) {
      this.setState({ waitingForPGDAcknowledgement: true });

      try {
        let didAcknowledge = await this.props.screenProps.acknowledgePGD(this.state.guidelineSummary);

        if (!didAcknowledge) {
          alert("The PGD couldn't be acknowledged. Please check your internet connection and try again");
        }
      } catch (error) {}

      this.setState({ waitingForPGDAcknowledgement: false });
    }
  }

  async acknowledgeGuideline() {
    if (this.state.guidelineSummary && this.state.guidelineSummary.SupportAcknowledment === true) {
      this.setState({ waitingForGLAcknowledgement: true });

      try {
        let didAcknowledge = await this.props.screenProps.acknowledgeGuideline(this.state.guidelineSummary);

        if (!didAcknowledge) {
          alert("The guideline couldn't be acknowledged. Please check your internet connection and try again");
        }
      } catch (error) {
        console.log(error);
      }

      this.setState({ waitingForGLAcknowledgement: false });
    }
  }

  generatePGDHeader() {
    if (
      this.state.guidelineSummary &&
      this.props.screenProps.user &&
      DataController.isAuthorisableGuideline(this.state.guidelineSummary)
    ) {
      let guidelineSummary = this.state.guidelineSummary;

      let trust = this.props.screenProps.trust;
      let result = "";
      let boxMessage = "";
      let expiryMessage = "";
      let pgdType = "PGD";
      if (DataController.isPMA(guidelineSummary)) {
        pgdType = "PMA";
      } else if (DataController.isSMG(guidelineSummary)) {
        pgdType = "Supplementary Medication Guideline";
        if (trust === "EMAS") {
          pgdType = "Medication Supply Guidelines";
        }
      }

      let pgdAck: IPGDAck | null | undefined = null;
      if (DataController.isAuthorisableGuideline(this.state.guidelineSummary)) {
        pgdAck = this.props.screenProps.pgdAcks.find((aPgdAck) => aPgdAck.GLID === guidelineSummary.GLID);
      }

      let pgdButtonLayout = null;

      let pgdTrustInfo = this.props.screenProps.pgdTrustInfo;

      let pgdStatus = DataController.getPGDStatus(guidelineSummary, pgdAck, pgdTrustInfo);

      if (pgdStatus === "UnauthorisedTakeQuiz") {
        boxMessage = "Please take the quiz through the ParaPass App";
      } else if (pgdStatus === "UnauthorisedQuizTaken" || pgdStatus === "UnauthorisedAcknowledge") {
        if (pgdTrustInfo) {
          if (DataController.isPMA(this.state.guidelineSummary)) {
            boxMessage =
              pgdTrustInfo.pmaAuthorisationText != null && pgdTrustInfo.pmaAuthorisationText !== ""
                ? pgdTrustInfo.pmaAuthorisationText
                : "Please acknowledge this disclaimer to authorise.";
          } else if (DataController.isPGD(this.state.guidelineSummary)) {
            boxMessage =
              pgdTrustInfo.authorisationText !== ""
                ? pgdTrustInfo.authorisationText
                : "Please acknowledge this disclaimer to authorise. By acknowledging this patient group direction you are indicating that you agree to its contents and that you will work within it. Patient group directions do not remove inherent professional obligations or accountability. It is the responsibility of each professional to practise only within the bounds of their own competence and professional code of conduct. I confirm that I have read and understood the content of this Patient Group Direction and that I am willing and competent to work to it within my professional code of conduct.";
          } else if (DataController.isSMG(this.state.guidelineSummary)) {
            boxMessage =
              pgdTrustInfo.smgAuthorisationText != null && pgdTrustInfo.smgAuthorisationText !== ""
                ? pgdTrustInfo.smgAuthorisationText
                : "Please acknowledge this disclaimer to authorise.";
          }
        }
      }

      if (
        pgdStatus === "UnauthorisedTakeQuiz" ||
        pgdStatus === "UnauthorisedQuizTaken" ||
        pgdStatus === "UnauthorisedAcknowledge"
      ) {
        if (pgdAck != null && pgdAck.PreviousAckTimes) {
          let previousAckTimes: string[] = JSON.parse(pgdAck.PreviousAckTimes);
          if (previousAckTimes.length > 0) {
            let latestPreviousAckTime = previousAckTimes[previousAckTimes.length - 1];
            let latestPreviousAckDate = this.formatDate(latestPreviousAckTime);
            boxMessage += `\n\nYour ${pgdType} authorisation has expired. You last authorised it on ${latestPreviousAckDate}.`;
          }
        }
      }

      if (
        pgdStatus === "Authorised" &&
        DataController.isPMA(guidelineSummary) &&
        pgdTrustInfo?.pmaDuration != null &&
        pgdTrustInfo.pmaDuration > 0
      ) {
        if (pgdAck && pgdAck.ACKTime != null) {
          try {
            let ackDate = new Date(pgdAck.ACKTime);
            let oneYearAfterAckDate = addYears(ackDate, 1);
            let pmaExpiryDate = this.formatDate(oneYearAfterAckDate.toISOString());
            expiryMessage += `\nYou are authorised until ${pmaExpiryDate}`;
          } catch (error) {}
        }
      }

      var borderStyle = "pgd-dim-borders";
      if (
        pgdStatus === "UnauthorisedTakeQuiz" ||
        pgdStatus === "UnauthorisedQuizTaken" ||
        pgdStatus === "UnauthorisedAcknowledge"
      ) {
        borderStyle = "pgd-standard-borders pgd-red-background";
      } else if (pgdStatus === "Authorised") {
        borderStyle = "pgd-standard-borders";
      }

      pgdButtonLayout = (
        <div>
          <IonButton
            className="pgdButton filledButton"
            disabled={this.state.waitingForPGDAcknowledgement}
            onClick={this.acknowledgePGD.bind(this)}
          >
            Acknowledge
            {this.state.waitingForPGDAcknowledgement ? <IonSpinner className="pgdAcknowledgementSpinner" /> : null}
          </IonButton>
        </div>
      );

      if (pgdStatus === "InformationOnly") {
        return (
          <div className="pgdHeader">
            <div className="pgdInfoBox">Information Only</div>
          </div>
        );
      } else if (pgdStatus === "NoAuth") {
        return <div></div>;
      } else if (pgdStatus === "UnauthorisedTakeQuiz") {
        return (
          <div className="pgdHeader">
            <div className="pgdRedBox">
              <div className="pgdRedBoxTitle">UNAUTHORISED</div>
              {boxMessage}
            </div>
            <div>
              <IonButton className="pgdButton filledButton" onClick={this.takeParaPassPGDQuiz.bind(this)}>
                Take Quiz
              </IonButton>
            </div>
          </div>
        );
      } else if (pgdStatus === "UnauthorisedQuizTaken" || pgdStatus === "UnauthorisedAcknowledge") {
        return (
          <div className="pgdHeader">
            <div className="pgdRedBox">
              <div className="pgdRedBoxTitle">UNAUTHORISED</div>
              <div className="pgdBoxMessage">{boxMessage}</div>
            </div>
            {pgdButtonLayout}
          </div>
        );
      } else if (pgdStatus === "Authorised") {
        return (
          <div className="pgdHeader">
            <div className="pgdAuthorisedBox">
              Authorised
              {expiryMessage}
              {DataController.isPMA(guidelineSummary) ? (
                <div>
                  <br />
                  You can extend your PMA authorisation date by completing the PMA quiz again.
                  <div>
                    <IonButton className="pgdButton filledButton" onClick={this.takeParaPassPGDQuiz.bind(this)}>
                      Take Quiz
                    </IonButton>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        );
      }
    }

    return null;
  }

  generateGuidelineAcknowledgmentHeader() {
    if (this.state.guidelineSummary && this.state.guidelineSummary.SupportAcknowledment === true) {
      let isAcknowledged = false;

      let guidelineSummary = this.state.guidelineSummary;

      let glAck = null;
      glAck = this.props.screenProps.glAcks.find((aGLAck) => aGLAck.GLID === guidelineSummary.GLID);

      if (glAck && guidelineSummary.AcknowledgedTime) {
        let userAcknowledgedDate = new Date(glAck.timestamp);
        let guidelineAcknowledgmentUpdatedDate = new Date(guidelineSummary.AcknowledgedTime);

        if (userAcknowledgedDate > guidelineAcknowledgmentUpdatedDate) {
          isAcknowledged = true;
        }
      }

      if (isAcknowledged) {
        return (
          <div className="pgdHeader">
            <div className="pgdAuthorisedBox">Acknowledged</div>
          </div>
        );
      } else {
        return (
          <div className="guidelineAcknowledgementButtonContainer">
            <IonButton
              className="guidelineAcknowledgementButton filledButton"
              disabled={this.state.waitingForGLAcknowledgement}
              onClick={this.acknowledgeGuideline.bind(this)}
            >
              Acknowledge
              {this.state.waitingForGLAcknowledgement ? <IonSpinner className="pgdAcknowledgementSpinner" /> : null}
            </IonButton>
          </div>
        );
      }
    }

    return <div></div>;
  }

  generateTopAnnotation() {
    let annotations = this.state.guidelineSummary?.annotations;

    let topAnnotationsLayout = [];

    if (annotations) {
      for (let annotation of annotations) {
        let annotationIsForDrugTable = false;

        if (this.state.guideline) {
          annotationIsForDrugTable = DataController.isAnnotationForDrugTable(annotation, this.state.guideline);
        }

        let annotationReferenceParts = annotation.Reference.split(" - ");
        if (
          annotationIsForDrugTable === false &&
          (annotationReferenceParts.length === 2 || annotation.Reference.includes("All Sections"))
        ) {
          // annotation isn't for a particular section so it belongs at the top of the page

          let annotationNote = "";

          if (annotation["note (html)"] != null) {
            let userTrust = this.props.screenProps.trust;

            annotationNote = annotation["note (html)"];
            annotationNote = this.replaceImages(annotationNote);

            if (annotationReferenceParts[2] === "All Sections") {
            } else {
            }

            if (annotationNote.includes("<table")) {
              annotationNote = annotationNote.replace(
                /<table/g,
                '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; overflow-y: hidden;"><table'
              );
              annotationNote = annotationNote.replace(/<\/table>/g, "</table></div>");
            }

            if (annotationNote.includes("<table")) {
              annotationNote = annotationNote.replace(
                /<table/g,
                '<div scrollbar-x="false" scrollbar-y="false" style="overflow: auto; overflow-y: hidden;"><table'
              );
              annotationNote = annotationNote.replace(/<\/table>/g, "</table></div>");
            }

            // annotationNote = annotationNote.replace(/cm-link/g, 'a');

            topAnnotationsLayout.push(
              <div key={annotation.ID} className={`${userTrust}NoteBox`} style={{ fontSize: this.fontSize(16) }}>
                <div className={`${userTrust}NoteTitle`}>
                  {DataController.getTrustDisplayName(userTrust)} Additional Guidance
                </div>
                <div
                  className={`trustNoteData ${userTrust}NoteData`}
                  style={{ lineHeight: this.props.screenProps.lineHeightChange }}
                  dangerouslySetInnerHTML={{ __html: annotationNote }}
                />
              </div>
            );
          }
        }
      }
    }

    return topAnnotationsLayout;
  }

  toggleDrugModal(value: boolean) {
    this.props.screenProps.showStatusBar(value, "#008477");

    this.setState({
      drugModalVisible: value,
    });

    if (value === false) {
      this.setState({ drugModalFiltered: false });
    }
  }

  toggleDrug2Modal(value: boolean) {
    this.props.screenProps.showStatusBar(value, "#008477");

    this.setState({
      drug2ModalVisible: value,
    });

    if (value === false) {
      this.setState({ drug2ModalFiltered: false });
    }
  }

  toggleFontModal(value: boolean, event: any) {
    // console.log('toggling font modal: ' + value);
    this.setState({
      fontModalVisible: value,
      fontModalEvent: event,
    });
    if (value === true) {
      RemoteDataController.logEvent("accessability_popover_opened", {
        from: "guideline",
      });
    }
  }

  toggleBookmarkSuggestionModal(value: boolean, event: any) {
    this.setState({
      bookmarkSuggestionModalVisible: value,
      bookmarkSuggestionModalEvent: event,
    });

    if (value === false) {
      DataController.saveBookmarkSuggestionDismissed();
    }
  }

  toggleAbbreviationPopover(value: boolean, event: any, abbreviation: IAbbreviation | null) {
    // console.log('toggling abbreviation popover: ' + value);
    this.setState({
      abbreviationPopoverVisible: value,
      abbreviationPopoverEvent: event,
      selectedAbbreviation: abbreviation,
    });
  }

  toggleImageModal(value: boolean, imageTag?: string) {
    this.props.screenProps.showStatusBar(value, "#008477");

    if (imageTag) {
      let html = imageTag.replace('class="img11"', "");

      this.setState({
        imageSrc: html,
        imageModalVisible: value,
      });
    } else {
      this.setState({
        imageModalVisible: value,
      });
    }
  }

  async readGuideline(subsection?: number) {
    try {
      await this.stopReading();
      await DataController.waitForMilliseconds(500);

      if (subsection == null) {
        await this.openAllSections();
      }

      let content: HTMLElement | null = null;

      if (subsection != null) {
        if (this.state.guideline) {
          let cardContent: HTMLElement = document.getElementById(
            `${this.props.match.params.tab}-${this.state.guideline.GLID}-content-${subsection}`
          ) as HTMLElement;
          if (cardContent != null) {
            content = cardContent;
          }
        }
      } else {
        let tab = this.props.match.params.tab;

        if (tab === "dashboard") {
          content = document.getElementById("dashboard-guideline-content");
        } else if (tab === "guidelines") {
          content = document.getElementById("guidelines-guideline-content");
        } else if (tab === "meds") {
          content = document.getElementById("meds-guideline-content");
        } else if (tab === "pageforage") {
          content = document.getElementById("pageforage-guideline-content");
        }
      }

      let text: string = "";

      if (content != null && content.innerText != null) {
        text = content.innerText;
        text = text.replace(/\n/g, ". ");
        text = text.replace(/\.\./g, ".");
        text = text.replace(/Play section/g, "");
        if (text.startsWith(". ")) {
          text = text.slice(2); // remove leading period space
        }

        let supportedLanguages = await TextToSpeech.getSupportedLanguages();

        if (supportedLanguages.languages.length > 0) {
          let remainingText = text + "";
          await this.setStateAsync({ remainingTextToSpeechText: remainingText });

          while (this.state.remainingTextToSpeechText.length > 0) {
            let text = this.state.remainingTextToSpeechText.substring(0, 3000);

            remainingText = this.state.remainingTextToSpeechText.substring(3000);

            await this.setStateAsync({ remainingTextToSpeechText: remainingText });

            let speechSpeed = DataController.convertTextToSpeechSpeed(this.props.screenProps.textToSpeechSpeed);

            let textToSpeechProperties: TTSOptions = {
              text: text,
              rate: speechSpeed,
              pitch: 1.0,
              volume: 1.0,
              category: "playback",
            };

            if (supportedLanguages.languages.includes("en-GB")) {
              textToSpeechProperties.lang = "en-GB";
            }

            await TextToSpeech.speak(textToSpeechProperties);

            if (this.state.guidelineSummary) {
              try {
                RemoteDataController.logEvent("text_spoken", {
                  from: "guideline",
                  glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
                  section: subsection ? subsection : "All",
                });
              } catch (error) {}
            }
          }
        }

        // const synth = window.speechSynthesis;
        // let voices = synth.getVoices();

        // const utterThis = new SpeechSynthesisUtterance(text);
        // utterThis.voice = voices[0];
        // utterThis.pitch = 1;
        // utterThis.rate = 1;

        // utterThis.addEventListener('boundary', (event) => {
        //   if (content != null) {
        //     let word = text.substr(event.charIndex, event.charLength);
        //     let htmlIndex = this.textIndexToHTMLIndex(event.charIndex, event.charIndex + event.charLength, text, content.innerHTML);
        //     let html = content.innerHTML.substr(htmlIndex[0], htmlIndex[1] - htmlIndex[0]);
        //     let newHtml = content.innerHTML.substring(0, htmlIndex[0]) + '<span class="red">' + html + '</span>' + content.innerHTML.substring(htmlIndex[1]);
        //     content.innerHTML = newHtml;
        //     console.log(`${word} reached after ${event.elapsedTime} seconds.`);
        //   }
        // });

        // synth.speak(utterThis);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async stopReading() {
    await this.setStateAsync({ remainingTextToSpeechText: "" });
    await TextToSpeech.stop();
  }

  textIndexToHTMLIndex(startIndex: number, endIndex: number, innerText: string, innerHTML: string) {
    var stringToSearch = innerText.substring(startIndex, endIndex);
    var occurInInnerText = this.getIndicesOf(stringToSearch, innerText, true);
    var whichOccurence = occurInInnerText.indexOf(startIndex);
    var stringToSearchInHTML = stringToSearch
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/\n/g, "<br>");
    var occurencesInHTML = [];
    var isChecking = true;
    for (var i = 0; i < innerHTML.length; i++) {
      if (stringToSearchInHTML == stringToSearch) {
        if (innerHTML.charAt(i) == "<" || innerHTML.charAt(i) == "&") {
          isChecking = false;
        } else if (innerHTML.charAt(i - 1) == ">" || innerHTML.charAt(i - 1) == ";") {
          isChecking = true;
        }
      } else {
        if (innerHTML.charAt(i) == "<") {
          isChecking = false;
        } else if (innerHTML.charAt(i - 1) == ">") {
          isChecking = true;
        }
      }
      if (isChecking) {
        if (innerHTML.substring(i, i + stringToSearchInHTML.length) == stringToSearchInHTML) {
          occurencesInHTML.push(i);
        }
      }
    }
    let startIndexInHTML = occurencesInHTML[whichOccurence];
    let endIndexInHTML = startIndexInHTML + stringToSearchInHTML.length;
    return [startIndexInHTML, endIndexInHTML];
  }

  getIndicesOf(searchStr: string, str: string, caseSensitive: boolean) {
    var searchStrLen = searchStr.length;
    if (searchStrLen == 0) {
      return [];
    }
    var startIndex = 0,
      index,
      indices = [];
    if (!caseSensitive) {
      str = str.toLowerCase();
      searchStr = searchStr.toLowerCase();
    }
    while ((index = str.indexOf(searchStr, startIndex)) > -1) {
      indices.push(index);
      startIndex = index + searchStrLen;
    }
    return indices;
  }

  highlightReadingWord() {
    let content: HTMLElement | null = null;
    let tab = this.props.match.params.tab;

    if (tab === "dashboard") {
      content = document.getElementById("dashboard-guideline-content");
    } else if (tab === "guidelines") {
      content = document.getElementById("guidelines-guideline-content");
    } else if (tab === "meds") {
      content = document.getElementById("meds-guideline-content");
    } else if (tab === "pageforage") {
      content = document.getElementById("pageforage-guideline-content");
    }

    let text: string = "";

    if (content != null && content?.textContent != null) {
      text = content.innerText;
      text = text.replace(/\n/g, ". ");
      text = text.replace(/\.\./g, ".");
    }
  }

  searchValueChanged(searchText: string) {
    let value = searchText
      .toLowerCase()
      .replace(/\(/g, "\\(")
      .replace(/\)/g, "\\)")
      .replace(/\{/g, "\\{")
      .replace(/\}/g, "\\}")
      .replace(/\./g, "\\.");

    let content;
    let tab = this.props.match.params.tab;

    if (tab === "dashboard") {
      content = document.getElementById("dashboard-guideline-content");
    } else if (tab === "guidelines") {
      content = document.getElementById("guidelines-guideline-content");
    } else if (tab === "meds") {
      content = document.getElementById("meds-guideline-content");
    } else if (tab === "pageforage") {
      content = document.getElementById("pageforage-guideline-content");
    }

    let text: string | null = null;

    if (content !== null && content !== undefined) {
      text = content.textContent;
    }

    this.setState({
      searchText: searchText,
    });

    try {
      // const regex = new RegExp(value, 'gi');
      // const result = [];

      // if ((text !== null && text !== undefined) && value.length > 1) {
      //   text = text.replace('Showing for age: All AllAdult18+16 to 1812 to AdultChild12 to 16 years11 years10 years9 years8 years7 years6 years5 years4 years3 years2 years18 monthsInfant12 months9 months6 months3 months1 monthBirth', '')

      //   while (regex.exec(text.toLowerCase())) {
      //     result.push(regex);
      //   }
      // }

      setTimeout(() => {
        let occurencesLength = 0;

        let content = null;
        let tab = this.props.match.params.tab;
        if (tab === "dashboard") {
          content = document.getElementById("dashboard-guideline-content");
        } else if (tab === "guidelines") {
          content = document.getElementById("guidelines-guideline-content");
        } else if (tab === "meds") {
          content = document.getElementById("meds-guideline-content");
        } else if (tab === "pageforage") {
          content = document.getElementById("pageforage-guideline-content");
        }

        if (content !== null && content !== undefined) {
          occurencesLength = content.getElementsByClassName("searchHighlight").length;
        }

        if (occurencesLength > 0 && text !== null) {
          this.setState({
            searchIndex: 1,
            searchOccurences: occurencesLength,
          });
        } else {
          this.setState({
            searchIndex: 0,
            searchOccurences: 0,
          });
        }
      }, 100);
    } catch (error) {
      this.setState({
        searchIndex: 0,
        searchOccurences: 0,
        searchText: searchText,
      });
      console.log(error);
    }
  }

  nextOccurence() {
    const searchBarIndex = this.state.searchIndex;

    if (searchBarIndex !== 0) {
      let content;
      let tab = this.props.match.params.tab;
      let occurences: any;

      if (tab === "dashboard") {
        content = document.getElementById("dashboard-guideline-content");
      } else if (tab === "guidelines") {
        content = document.getElementById("guidelines-guideline-content");
      } else if (tab === "meds") {
        content = document.getElementById("meds-guideline-content");
      } else if (tab === "pageforage") {
        content = document.getElementById("pageforage-guideline-content");
      }

      if (content !== null && content !== undefined) {
        occurences = content.getElementsByClassName("searchHighlight");
      }

      if (searchBarIndex === occurences.length) {
        occurences[0].className = "searchHighlight searchHighlightCurrent";
        occurences[occurences.length - 1].className = "searchHighlight";

        this.scrollToHighlight(occurences[0], "center");

        this.setState({
          searchIndex: 1,
        });
      } else {
        try {
          occurences[searchBarIndex].className = "searchHighlight searchHighlightCurrent";
          occurences[searchBarIndex - 1].className = "searchHighlight";

          this.scrollToHighlight(occurences[searchBarIndex], "center");

          this.setState({
            searchIndex: searchBarIndex + 1,
          });
        } catch (error) {
          console.log(error);
        }
      }
    }
  }

  previousOccurence() {
    const searchBarIndex = this.state.searchIndex;

    if (searchBarIndex !== 0) {
      let content;
      let tab = this.props.match.params.tab;
      let occurences: any;

      if (tab === "dashboard") {
        content = document.getElementById("dashboard-guideline-content");
      } else if (tab === "guidelines") {
        content = document.getElementById("guidelines-guideline-content");
      } else if (tab === "meds") {
        content = document.getElementById("meds-guideline-content");
      } else if (tab === "pageforage") {
        content = document.getElementById("pageforage-guideline-content");
      }

      if (content !== null && content !== undefined) {
        occurences = content.getElementsByClassName("searchHighlight");
      }

      if (searchBarIndex === 1 && occurences.length > 0) {
        occurences[occurences.length - 1].className = "searchHighlight searchHighlightCurrent";
        occurences[0].className = "searchHighlight";

        this.scrollToHighlight(occurences[occurences.length - 1], "center");

        this.setState({
          searchIndex: occurences.length,
        });
      } else {
        occurences[searchBarIndex - 2].className = "searchHighlight searchHighlightCurrent";
        occurences[searchBarIndex - 1].className = "searchHighlight";

        this.scrollToHighlight(occurences[searchBarIndex - 2], "center");

        this.setState({
          searchIndex: searchBarIndex - 1,
        });
      }
    }
  }

  scrollToHighlight(element: any, block: "start" | "center" | "end") {
    try {
      let parent = element.parentElement;
      let cardFound = false;

      while (parent !== null || !cardFound) {
        if (parent.id.includes("content-")) {
          let content: HTMLElement = document.getElementById(`${parent.id}`) as HTMLElement;
          let icon: HTMLImageElement = document.getElementById(`${parent.id}-icon`) as HTMLImageElement;

          if (content !== null && icon !== null) {
            if (content.hidden) {
              content.hidden = false;
              icon.src = this.props.screenProps.darkMode ? iconMinusDark : iconMinus;
            }
          }

          cardFound = true;
        }

        parent = parent.parentElement;
      }
    } catch (error) {
      console.log(error);
    }

    element.scrollIntoView({ behavior: "smooth", block: block });
  }

  goToSubsectionWithName(sectionName: string) {
    try {
      let subsection = 0;

      if (this.state.guideline && this.state.guideline.sections) {
        for (
          let guidelineSectionIndex = 0;
          guidelineSectionIndex < this.state.guideline.sections.length;
          guidelineSectionIndex++
        ) {
          let guidelineSection = this.state.guideline.sections[guidelineSectionIndex];
          if (guidelineSection.SectionTitle === sectionName) {
            subsection = guidelineSectionIndex + 1;
          }
        }
      }

      if (this.state.guideline) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${this.state.guideline.GLID}-content-${subsection - 1}`
        ) as HTMLElement;
        if (cardContent != null) {
          if (cardContent.childNodes.length > 0) {
            setTimeout(() => {
              this.scrollToHighlight(cardContent.childNodes[0], "start");
            }, 1000);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  goToSubsection(subsection: string) {
    try {
      let correctedSubsection = parseInt(subsection);

      if (this.state.guideline) {
        let cardContent: HTMLElement = document.getElementById(
          `${this.props.match.params.tab}-${this.state.guideline.GLID}-content-${correctedSubsection - 1}`
        ) as HTMLElement;
        if (cardContent != null) {
          if (cardContent.childNodes.length > 0) {
            setTimeout(() => {
              this.scrollToHighlight(cardContent.childNodes[0], "start");
            }, 1000);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  goToId(id: string) {
    try {
      if (this.state.guideline) {
        let idElement: HTMLElement = document.getElementById(id) as HTMLElement;
        if (idElement != null) {
          setTimeout(() => {
            this.scrollToHighlight(idElement, "start");
          }, 1000);
        } else {
          // check if id is for a section (which needs to be hashed first)
          let sectionId = id;
          if (sectionId) {
            let dashPos = sectionId.indexOf("-");
            let underscorePos = sectionId.indexOf("_");
            if (dashPos != -1 && underscorePos != -1) {
              sectionId = sectionId.substring(dashPos + 1, underscorePos);
            } else {
              sectionId = sectionId.replace("-", "");
            }
            if (sectionId.startsWith("A")) {
              sectionId = sectionId.substring(1);
            }
            let sectionIDHash = this.getHash(sectionId);
            let idElement: HTMLElement = document.getElementById(sectionIDHash) as HTMLElement;
            if (idElement != null) {
              setTimeout(() => {
                this.scrollToHighlight(idElement, "start");
              }, 1000);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  getHash(input: string) {
    var hash = 0,
      len = input.length;
    for (var i = 0; i < len; i++) {
      hash = (hash << 5) - hash + input.charCodeAt(i);
      hash |= 0; // to 32bit integer
    }
    return "" + hash;
  }

  goToFigure(figure: string) {
    if (document != null) {
      // first try looking for caption1 tag
      let captionFound = false;
      let captions = document.querySelectorAll("caption1");
      for (let captionIndex = 0; captionIndex < captions.length; captionIndex++) {
        let caption = captions[captionIndex];
        if (caption.textContent != null) {
          if (caption.textContent.includes(figure)) {
            captionFound = true;
            setTimeout(() => {
              this.scrollToHighlight(caption, "center");
            }, 500);
          }
        }
      }
      // if couldn't find search for any bold text
      if (captionFound === false) {
        captions = document.querySelectorAll("b");
        for (let captionIndex = 0; captionIndex < captions.length; captionIndex++) {
          let caption = captions[captionIndex];
          if (caption.textContent != null) {
            if (caption.textContent.includes(figure)) {
              captionFound = true;
              setTimeout(() => {
                this.scrollToHighlight(caption, "center");
              }, 500);
            }
          }
        }
      }
    }
  }

  goToTable(tableName: string) {
    if (document != null) {
      // first try looking for table3 tag
      let tableFound = false;
      let tables = document.querySelectorAll("jrcalctable");
      for (let tableIndex = 0; tableIndex < tables.length; tableIndex++) {
        let table = tables[tableIndex];
        if (table.textContent != null) {
          if (table.textContent.includes(tableName)) {
            tableFound = true;
            setTimeout(() => {
              this.scrollToHighlight(table, "start");
            }, 500);
          }
        }
      }
    }
  }

  fontSize(size: number) {
    return `${size + this.props.screenProps.fontSizeChange}px`;
  }

  addSubSubsections(originalHtml: string) {
    let html = originalHtml + "";

    try {
      var htmlContent = document.createElement("div");
      htmlContent.className = "AACE-Section-body";
      htmlContent.innerHTML = originalHtml;

      let subsectionElements = htmlContent.getElementsByTagName("publ_subsection");

      for (let subsectionIndex = 0; subsectionIndex < subsectionElements.length; subsectionIndex++) {
        let tElem = subsectionElements[subsectionIndex];

        var theParent = tElem.parentElement;
        if (theParent != null && theParent.getAttribute("class") === "subSubSection") {
          // may effect Safeguarding in EEAST so going for SWAST o
          var publ_section_title_elements = tElem.getElementsByTagName("publ_section_title");
          if (publ_section_title_elements.length > 0) {
            var publ_section_title_element = publ_section_title_elements[0];
            var sectionTitle = publ_section_title_element.innerHTML;
            var outhtmlTtile = publ_section_title_element.outerHTML;
            if (sectionTitle != null && sectionTitle.length > 0) {
              if (sectionTitle.indexOf("7.8.1") !== -1) {
                console.log('sectionTitle.indexOf("7.8.1")');
              }
              // remove from html text and put title in wiht a style based on level.
              var localhtml = tElem.innerHTML;
              var countDots = this.count(sectionTitle, ".");
              localhtml = this.replaceAfter(
                localhtml,
                outhtmlTtile,
                sectionTitle,
                "<div class=subSectionTitle" + countDots + ">" + sectionTitle + "</div>"
              );
              // remove the publ_section_title
              localhtml = localhtml.replace(outhtmlTtile, "");
              var result = "<div class=subSubSection>" + localhtml + "</div>";
              tElem.innerHTML = result;
            } else {
              console.log("");
            }
            var result = "<div class=subSubSection>" + tElem.innerHTML + "</div>";
            // return result;
          }
        } else if (theParent != null) {
          // Directly under a collapsed section
          // only one level of collasables

          var publ_section_title_elements = tElem.getElementsByTagName("publ_section_title");
          if (publ_section_title_elements.length > 0) {
            var publ_section_title_element = publ_section_title_elements[0];

            var sectionTitle = publ_section_title_element.innerHTML;
            var outhtmlTtile = publ_section_title_element.outerHTML;
            var localhtml = tElem.innerHTML;
            // console.log (theParent.attr('class')+'---'+outhtmlTtile);
            var countDots = this.count(sectionTitle, ".");
            localhtml = this.replaceAfter(
              localhtml,
              outhtmlTtile,
              sectionTitle,
              "<div class=subSectionTitle" + countDots + ">" + sectionTitle + "</div>"
            );

            // remove the publ_section_title
            localhtml = localhtml.replace(outhtmlTtile, "");

            var result = "<div class=subSubSection>" + localhtml + "</div>";
            tElem.innerHTML = result;
          }
        }
      }

      html = htmlContent.innerHTML;
    } catch (error) {
      console.log(error);
    }

    return html;
  }

  replaceAfter(localhtml: string, afterStr: string, replacementStr: string, replacementWithStr: string) {
    var pos = localhtml.indexOf(afterStr);

    if (pos !== -1) {
      var firstBit = localhtml.substr(0, pos + afterStr.length);
      var rest = localhtml.substr(pos + afterStr.length);
      rest = rest.replace(replacementStr, replacementWithStr);
      var result = firstBit + rest;
      return result;
    } else {
      var result = localhtml.replace(replacementStr, replacementWithStr);
      return result;
    }
  }

  count(stringToSearch: string, stringToFind: string) {
    return stringToSearch.split(stringToFind).length - 1;
  }

  hasAgePicker() {
    let hasAgePicker = false;

    if (this.state.guideline && this.state.guidelineSummary) {
      let tables = TableHandler.getDrugTable(this.state.guideline);
      if (
        DataController.isDrug(this.state.guidelineSummary) &&
        DataController.isPageForAge(this.state.guidelineSummary.GLID) === false &&
        tables != null &&
        tables.length > 0
      ) {
        hasAgePicker = true;
      }
    }

    return hasAgePicker;
  }

  replaceImages(originalHtml: string) {
    let guideline = this.state.guideline;
    if (guideline == null) {
      return originalHtml;
    }

    let html = originalHtml;

    html = originalHtml.replace(/src="/g, 'class="img11" src="');
    html = html.replace(/\.png/g, ".jpg");

    if (html.includes("http://www.cm.class.community.librios.com/Media/")) {
      html = html.replace(/http:\/\/www.cm.class.community.librios.com\/Media\//g, "");
    }

    // replace image paths
    let matches: any[] | null = [];
    let imageUrls = [];
    let imageRegex = /<img.*?src=['"](.*?)['"]/g;

    try {
      while ((matches = imageRegex.exec(html))) {
        imageUrls.push(matches[1]);
      }

      for (let imageIndex = 0; imageIndex < imageUrls.length; imageIndex++) {
        let imageUrl = imageUrls[imageIndex];
        let bundledImage = DataController.getBundledImageData({
          imageName: imageUrl,
          trust: this.state.guidelineSummary?.trust,
        });
        html = html.replace(`src="${imageUrl}"`, `src="${bundledImage}"`);
      }
    } catch (error) {
      console.log(error);
    }

    // if image is downloaded rather than bundled - try to replace it here
    if (_.findIndex(this.props.screenProps.images, (_image: any) => _image.name.includes(guideline?.GLID)) !== -1) {
      let images = this.props.screenProps.images.filter((_image: any) => _image.name.includes(guideline?.GLID));

      for (let i = 0; i < images.length; i++) {
        let image = images[i];
        html = html.replace(`src="${image.name}"`, `src="${image.data}"`);
      }
    }
    return html;
  }

  significantChangeCellAcknowledgeButtonClicked(significantChange: ISignificantChange) {
    this.props.screenProps.acknowledgeSignificantChange(significantChange, "Guideline");
  }

  patientAgeChanged(patientAge: IPatientAge) {
    this.props.screenProps.updatePatientAge(patientAge, "Guideline");

    if (this.state.guidelineSummary) {
      try {
        RemoteDataController.logEvent("med_navigation", {
          name: "Patient Age Changed",
          value: patientAge.name,
          glid: this.props.screenProps.getGuidelineTitleForLogging(this.state.guidelineSummary.GLID),
        });
      } catch (error) {
        console.log(error);
      }
    }
  }

  pageForAgeResetButtonClicked() {
    let ageObjects = DataController.getAgesObjects();
    let allAge = ageObjects.find((anAge) => anAge.name === "All");
    if (allAge != null) {
      this.props.screenProps.updatePatientAge(allAge, "Guideline Reset");
    }
  }

  goBack() {
    // if (this.props.location.state !== undefined
    //   && this.props.location.state.pushed) {
    //   this.props.history.goBack();
    // } else {
    //   this.props.history.replace(`/${this.props.match.params.tab}`);
    // }
  }

  setStateAsync(state: any) {
    return new Promise((resolve: any) => {
      this.setState(state, resolve);
    });
  }

  render() {
    let guideline = this.state.guideline;
    let guidelineSummary = this.state.guidelineSummary;

    if (guideline == null || guidelineSummary == null) {
      let messageText = "Guideline is loading";

      if (this.props.screenProps.messageBarText === "") {
        messageText = "Guideline couldn't be loaded. It might not exist or has been removed.";
      }

      return (
        <IonPage>
          <IonHeader>
            <IonToolbar mode="ios" className="navBar">
              <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
                <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent ref={this.ionContent}>
            <div className="emptyPageContainer">
              <div className="emptyPageText">{messageText}</div>
            </div>
          </IonContent>
        </IonPage>
      );
    }

    const sections = this.state.sections;
    const quicklook = this.getQuicklook(guideline);
    let pgdHeader = this.generatePGDHeader();
    let guidelineAcknowledgmentHeader = this.generateGuidelineAcknowledgmentHeader();
    let topAnnotation = this.generateTopAnnotation();
    const isDrug = DataController.isDrug(guideline);
    const isBookmarked = this.isBookmarked();
    let guidelineTrust = guideline.trust;

    let title = "";
    let drugTitle = "";

    if (guideline && guideline.title) {
      title = guideline.title;
    }

    let guidelineType = guideline["Section"];
    if ((guidelineType == null || guidelineType === "") && guidelineTrust != null) {
      guidelineType = guidelineTrust;
    }

    if (isDrug && guideline["cpg-guideline-subtitle"]) {
      drugTitle = guideline["cpg-guideline-subtitle"];
    }

    let modalTitle: string = guideline["cpg-guideline-subtitle"] ? guideline["cpg-guideline-subtitle"] : "";

    if (this.state.searchText.length > 1) {
      title = DataController.addHighlight(title, this.state.searchText);
    }

    let updatedString = " - ";
    if (guideline.UpdatedDisplay) {
      try {
        let updatedDate = new Date(guideline.UpdatedDisplay);
        let updatedDateText = format(updatedDate, "do MMMM yyyy");
        updatedString = ` - Updated ${updatedDateText} - `;
      } catch (error) {}
    }

    const versionNumber = `${guideline.GLID}${updatedString}Version ${guideline["publ_major_version_no"]}.${guideline["publ_minor_version_no"]}`;

    const alertHeader = this.state.unavailable.GLID !== undefined ? `Unavailable` : "";

    const alertMessage =
      this.state.unavailable.title !== undefined ? `${this.state.unavailable.title} is not available` : "";

    // layout significant change boxes
    let unacknowledgedSignificantChangesLayout = [];
    let acknowledgedSignificantChangesLayout = [];

    for (
      let significantChangeIndex = 0;
      significantChangeIndex < this.props.screenProps.significantChanges.length;
      significantChangeIndex++
    ) {
      let significantChange = this.props.screenProps.significantChanges[significantChangeIndex];

      if (significantChange.GLID === guideline.GLID) {
        let significantChangeAck = this.props.screenProps.significantChangeAcks.find(
          (significantChangeAck) => significantChangeAck.cnid === significantChange.id
        );

        if (significantChangeAck == null) {
          let showAcknowledgeButton = false;
          if (this.props.screenProps.user && this.props.screenProps.user.uid != null) {
            showAcknowledgeButton = true;
          }

          unacknowledgedSignificantChangesLayout.push(
            <div key={significantChange.id} className="guidelinePageSignificantChangeCard">
              <SignificantChangeWarningCard
                key={significantChange.id}
                acknowledged={false}
                showAcknowledgeButton={showAcknowledgeButton}
                significantChange={significantChange}
                acknowledgeButtonClicked={this.significantChangeCellAcknowledgeButtonClicked.bind(this)}
              />
            </div>
          );
        } else {
          let titleText = significantChange.title;
          let dateText = significantChange.updated.date;
          let descriptionHtml = significantChange.description;

          let significantChangeTrust = significantChange.trust;
          let significantChangeTrustSection = "";
          if (significantChangeTrust == null || significantChangeTrust === "JRCALC") {
            significantChangeTrust = "JRCALC";
            significantChangeTrustSection = DataController.getSectionClass("SignificantChangeJRCALC");
          } else {
            significantChangeTrustSection = DataController.getSectionClass(significantChangeTrust);
          }

          acknowledgedSignificantChangesLayout.push(
            <div key={significantChange.id} className="guidelinePageSignificantChangeCard">
              <div className="significantChangeWarningCardDate">
                {dateText}
                <div className="significantChangeCellTrustDotSeparator" />
                <div className={`significantChangeCellTrust ${significantChangeTrustSection}`}>
                  {significantChangeTrust}
                </div>
              </div>
              <div className="significantChangeWarningCardTitle">{titleText}</div>

              <div
                className="significantChangeWarningCardDescription"
                dangerouslySetInnerHTML={{ __html: descriptionHtml }}
              />
              <div className="guidelinePageSignificantChangeCardSeparator" />
            </div>
          );
        }
      }
    }

    let drugModalClass = "";
    if (this.state.guidelineSummary) {
      if (DataController.isPageForAge(this.state.selectedGLID)) {
        drugModalClass = "pageForAge";
      } else if (DataController.isDrug(this.state.guidelineSummary)) {
        drugModalClass = "meds";
      } else {
        drugModalClass = DataController.getGuidelineClass(this.state.guidelineSummary);
      }
    }

    let separateTrustTopBar = null;
    let guidelineTrustText = null;
    if (guidelineTrust != null && DataController.getGuidelineClass(guidelineSummary) !== guidelineTrust) {
      // show separate colored bar for trust
      separateTrustTopBar = (
        <div className={`trustGuidelineBarDiv ${DataController.getSectionClass(guidelineTrust)}`}>
          <div className="trustGuidelineBarText globalContentMargin">
            {DataController.getTrustDisplayName(guidelineTrust)}
          </div>
        </div>
      );
    } else {
      // show compact single color bar
      if (guidelineTrust) {
        guidelineTrustText = (
          <div className="jrcalcGuidelineText globalContentMargin">
            {DataController.getTrustDisplayName(guidelineTrust)}
          </div>
        );
      } else if (DataController.isSharedProcedure(guidelineSummary)) {
        guidelineTrustText = <div className="jrcalcGuidelineText globalContentMargin">Shared Procedure</div>;
      } else {
        guidelineTrustText = <div className="jrcalcGuidelineText globalContentMargin">JRCALC Guideline</div>;
      }
    }

    let annotationBar = null;
    if (this.state.guidelineSummary && this.state.guidelineSummary.annotations) {
      let userTrust = this.props.screenProps.trust;

      annotationBar = (
        <div className={`annotationBarGuidelineDiv ${DataController.getSectionClass(userTrust)}`}>
          <div className="annotationBarGuidelineText globalContentMargin">
            Guideline contains {DataController.getTrustDisplayName(this.props.screenProps.trust)} additional guidance
          </div>
        </div>
      );
    }

    let pageTitle = "";
    if (isPageForAge(this.state.selectedGLID)) {
      let age = DataController.getAgesObjects().find((object) => object.PFA === this.state.selectedGLID);
      if (age != null) {
        pageTitle = age.name.toUpperCase();
      }
    } else if (isDrug) {
      pageTitle = drugTitle;
    }

    // hide page title if text will overlap buttons
    if (pageTitle.length > 9 || this.props.screenProps.showTextToSpeech) {
      pageTitle = "";
    }

    let containerClass = "";
    if (guideline.trust && this.props.screenProps.trust !== "") {
      if (DataController.isDrug(guidelineSummary)) {
        containerClass = guideline.trust + "ContainerDRUG";
      } else {
        containerClass = guideline.trust + "ContainerGL";
      }
    }

    let referenceCardImageTags: string[] = [];
    let imageThumbnailsLayout = [];

    let referenceCardImageNames: string[] = [];
    if (this.state.referenceCard) {
      if (this.state.referenceCard.imageNames) {
        referenceCardImageNames = this.state.referenceCard.imageNames;
      } else if (this.state.referenceCard.imageName) {
        referenceCardImageNames = [this.state.referenceCard.imageName];
      }
    }

    if (referenceCardImageNames.length > 1) {
      for (let thumbnailIndex = 0; thumbnailIndex < referenceCardImageNames.length; thumbnailIndex++) {
        let thumbnailName = referenceCardImageNames[thumbnailIndex];
        let imageTag = this.replaceImages(
          `<img id='imageModalThumbnail-${thumbnailIndex}' class='imageModalThumbnail ${
            thumbnailIndex === this.state.currentReferenceCardIndex ? "imageModalThumbnailActive" : ""
          }' src="${thumbnailName}">`
        );
        referenceCardImageTags.push(imageTag);
        imageThumbnailsLayout.push(<div dangerouslySetInnerHTML={{ __html: imageTag }} />);
      }
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle className="headerTitle">{pageTitle}</IonTitle>
            <IonButtons slot="end">
              {this.props.screenProps.showTextToSpeech ? (
                <>
                  <IonButton
                    aria-label="Play"
                    className="headerButtons audioHeaderButtons"
                    onClick={(event) => this.readGuideline()}
                  >
                    <IonImg src={iconPlayWhite} />
                  </IonButton>
                  <IonButton
                    aria-label="Stop"
                    className="headerButtons audioHeaderButtons"
                    onClick={(event) => this.stopReading()}
                  >
                    <IonImg src={iconStop} />
                  </IonButton>
                </>
              ) : null}
              <IonButton
                className="headerButtons"
                aria-label="Open Accessibility Menu"
                onClick={(event) => this.toggleFontModal(true, event)}
              >
                <IonImg src={iconAccessibility} />
              </IonButton>
              {guideline.GLID !== "GAUTH" ? (
                <div>
                  <IonButton
                    className="headerButtons"
                    aria-label={isBookmarked ? `Bookmarked` : `Bookmark`}
                    mode="ios"
                    onClick={() => this.bookmarkButtonPressed()}
                  >
                    <IonImg src={isBookmarked ? iconBookmarkActive : iconBookmarkInactive} />
                  </IonButton>
                  <div
                    id="bookmarkSuggestion"
                    onClick={(event) => this.toggleBookmarkSuggestionModal(true, event)}
                  ></div>
                </div>
              ) : null}
              <IonButton
                aria-label="Toggle Search"
                onClick={this.toggleSearch.bind(this, true)}
                className="headerButtons"
              >
                <IonImg src={this.state.showSearch ? iconSearchActive : iconSearchInactive} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
          {this.state.showSearch ? (
            <div className="guidelineSearchHeader">
              <IonButton className="searchDoneButton" mode="ios" onClick={this.toggleSearch.bind(this, true)}>
                Done
              </IonButton>
              <div className={`guidelinesSearchInputContainer`}>
                <img alt="" src={this.props.screenProps.darkMode ? iconSearchDark : iconSearch} className="icon-44" />
                <IonInput
                  type="search"
                  value={this.state.searchText}
                  className="searchInputField"
                  placeholder="Search within Guideline"
                  onIonInput={(event: any) => this.searchValueChanged(event.target.value)}
                  clearOnEdit={false}
                  ref={this.searchTextField}
                  onKeyDown={(event) => this.enterButtonClicked(event)}
                />
                {this.state.searchText !== "" ? (
                  <IonText className="occurences">{`${this.state.searchIndex} of ${this.state.searchOccurences}`}</IonText>
                ) : null}
              </div>
              <IonButton
                aria-label="Search Previous"
                fill="clear"
                className="searchNextPrevious"
                onClick={() => this.previousOccurence()}
              >
                <IonImg className="icon-36" src={buttonUp} />
              </IonButton>
              <IonButton
                aria-label="Search Next"
                fill="clear"
                className="searchNextPrevious"
                onClick={() => this.nextOccurence()}
              >
                <IonImg className="icon-36" src={buttonDown} />
              </IonButton>
            </div>
          ) : null}
        </IonHeader>

        <IonContent
          id={`${this.props.match.params.tab}-guideline-content`}
          className={`guidelineContent ${containerClass}`}
          ref={this.ionContent}
          scrollEvents={true}
          onIonScroll={this.handlePageScroll}
        >
          {separateTrustTopBar}
          <div className={`ACCEGuidelineTitle ${DataController.getGuidelineClass(guidelineSummary)}`}>
            {guidelineTrustText}
            <div
              className="globalContentMargin"
              style={{ fontSize: this.fontSize(21) }}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
          {annotationBar}

          <div className={`guidelineStickyAgeBanner ${DataController.getGuidelineClass(guidelineSummary)}`}>
            <div className="globalContentMargin">
              {DataController.isPageForAge(this.state.selectedGLID) && this.state.guidelineSummary ? (
                <div>
                  Displaying for patient age - {this.state.guidelineSummary.Title.replace("Page for Age: ", "")}
                </div>
              ) : (
                <>
                  <div className="guidelineStickyAgeBannerAgeTitle" dangerouslySetInnerHTML={{ __html: title }} />
                  <div>Displaying for patient age - {this.props.screenProps.patientAge.name}</div>
                </>
              )}
            </div>
          </div>

          {this.props.features.includes("medInfoOnlyNotices") && isDrug ? (
            <div>
              {/* <div className="padding"> */}
              <div className="warningContainer" style={{ flexDirection: "column-reverse" }}>
                {/* <IonGrid>
                  <IonRow>
                    <img
                      alt=""
                      src={iconError}
                      className="warningIcon"
                    /> */}
                <div
                  style={{
                    fontSize: this.fontSize(14),
                    lineHeight: this.fontSize(14) + 6,
                  }}
                  className="warningText globalContentMargin"
                >
                  {"Medicine guidelines are provided for information purposes only. Responders " +
                    "must practise according to the local policies of your organisation."}
                </div>
                {/* </IonRow>
                </IonGrid> */}
              </div>
            </div>
          ) : null}

          <div id="guidelineContent" className="globalContentMargin">
            {this.state.hasUpdate ? (
              <div>
                <div
                  className={isDrug ? "warningContainerUpdateDrug" : "warningContainerUpdate"}
                  style={{ flexDirection: "column-reverse" }}
                >
                  <IonGrid>
                    <IonRow>
                      <IonCol size="1" className="warningCol">
                        <img alt="" src={indicatorUpdate} className="warningIcon" />
                      </IonCol>
                      <IonCol>
                        <div
                          style={{
                            fontSize: this.fontSize(14),
                            lineHeight: this.props.screenProps.lineHeightChange,
                          }}
                          className="warningText"
                        >
                          {`This ${isDrug ? "medicine" : "guideline"} has been updated since you last viewed it.`}
                        </div>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </div>
              </div>
            ) : null}

            {unacknowledgedSignificantChangesLayout}

            {pgdHeader}

            {guidelineAcknowledgmentHeader}

            {this.hasAgePicker() ? (
              <div className="guidelineShowForAgeContainer">
                <span className="showForAge" style={{ fontSize: this.fontSize(20) }}>
                  {"Showing for age: "}
                </span>
                <div className="guidelinePageForAgeContentContainer">
                  <AgeSelector
                    className="guidelinePageForAgeSelect"
                    patientAge={this.props.screenProps.patientAge}
                    patientAgeChanged={(patientAge) => this.patientAgeChanged(patientAge)}
                  />
                  <IonButton
                    disabled={this.props.screenProps.patientAge.name === "All"}
                    className="guidelinePageForAgeResetButton filledButton"
                    onClick={this.pageForAgeResetButtonClicked.bind(this)}
                  >
                    Reset
                  </IonButton>
                </div>
              </div>
            ) : null}

            {this.props.screenProps.debugMode ? (
              <pre className="debugBox">{JSON.stringify(this.state.guidelineSummary, null, 2)}</pre>
            ) : null}

            {topAnnotation != null ? topAnnotation : null}

            {quicklook != null ? (
              <div>
                <div className="AACEQuickLookTitle">
                  {this.state.searchText.length > 1 ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DataController.addHighlight("QUICK LOOK", this.state.searchText),
                      }}
                    />
                  ) : (
                    "QUICK LOOK"
                  )}
                </div>
                <hr aria-hidden="true" className="AACENoMargin" />
                {quicklook}
              </div>
            ) : null}
            <div className="AACEQuickLookTitle">
              {this.state.searchText.length > 1 ? (
                <div
                  dangerouslySetInnerHTML={{
                    __html: DataController.addHighlight("REFERENCE", this.state.searchText),
                  }}
                />
              ) : (
                "REFERENCE"
              )}
            </div>
            <hr aria-hidden="true" className="AACENoMargin" />

            {this.getSectionsCount() > 1 ? (
              <div className="guidelineToggleSections" onClick={() => this.toggleAllSections()}>
                {this.state.toggleSectionsText}
              </div>
            ) : null}

            {sections}

            {acknowledgedSignificantChangesLayout.length > 0 ? (
              <div>
                <div className="AACEQuickLookTitle">ACKNOWLEDGEMENTS</div>
                <hr aria-hidden="true" className="AACENoMargin" />

                <IonCard className="card sectionCard" mode="md">
                  <IonCardHeader className="GLHeader" onClick={() => this.headerClicked(sections.length + 1)}>
                    <IonCardTitle className="greenTitle" style={{ fontSize: this.fontSize(18) }}>
                      <div dangerouslySetInnerHTML={{ __html: "Acknowledged Updates" }} />
                    </IonCardTitle>
                    <img
                      id={`${this.props.match.params.tab}-${guideline.GLID}-content-${sections.length + 1}-icon`}
                      src={this.props.screenProps.darkMode ? iconPlusDark : iconPlus}
                      alt=""
                      style={{
                        position: "absolute",
                        height: 44,
                        width: 44,
                        top: 0,
                        bottom: 0,
                        right: 6,
                        margin: "auto",
                      }}
                    />
                  </IonCardHeader>
                  <IonCardContent
                    mode="md"
                    className="guidelineCardContent text"
                    style={{ fontSize: this.fontSize(16), lineHeight: this.props.screenProps.lineHeightChange }}
                    id={`${this.props.match.params.tab}-${guideline.GLID}-content-${sections.length + 1}`}
                  >
                    <div>{acknowledgedSignificantChangesLayout}</div>
                  </IonCardContent>
                </IonCard>
              </div>
            ) : null}

            {this.state.displayParaPassQuizLink ? (
              <div>
                <div className="AACEQuickLookTitle">PARAPASS</div>
                <hr aria-hidden="true" className="AACENoMargin" />

                {this.props.screenProps.abTestingVersion === "A" ? (
                  <div className="guidelineParaPassQuizCardA">
                    <div className="guidelineParaPassQuizCardTitleA">TAKE A QUIZ</div>
                    <div className="guidelineParaPassQuizCardContentA">
                      <img src={iconParaPass} alt="" style={{ height: 64, width: 64 }} />
                      <div style={{ lineHeight: this.props.screenProps.lineHeightChange }}>
                        You have access to the ParaPass app. Practise your knowledge on this guideline by taking a quiz
                        in ParaPass.
                      </div>
                    </div>
                    <div className="guidelineParaPassQuizCardButtonContainerA">
                      <IonButton
                        className="guidelineParaPassQuizCardButtonA filledButton"
                        onClick={this.takeParaPassQuiz.bind(this)}
                      >
                        Take quiz in ParaPass
                      </IonButton>
                    </div>
                  </div>
                ) : (
                  <div className="guidelineParaPassQuizCardB">
                    <img src={iconParaPass} alt="" style={{ height: 48, width: 48, marginTop: 8 }} />
                    <div className="guidelineParaPassQuizCardTitleB">Practice CPD with ParaPass</div>
                    <div className="guidelineParaPassQuizCardContentB">
                      <div style={{ lineHeight: this.props.screenProps.lineHeightChange }}>
                        You currently have access to the ParaPass app and can take a quiz on this guideline
                      </div>
                    </div>
                    <div className="guidelineParaPassQuizCardButtonContainerB">
                      <IonButton
                        className="guidelineParaPassQuizCardButtonB filledButton"
                        onClick={this.takeParaPassQuiz.bind(this)}
                      >
                        Take a quiz
                      </IonButton>
                    </div>
                  </div>
                )}
              </div>
            ) : null}

            <div className="versionNumber">{versionNumber}</div>

            <IonAlert
              buttons={["Dismiss"]}
              isOpen={this.state.alertOpen}
              onDidDismiss={() => this.setAlertVisible(false)}
              header={this.state.unavailable.GLID !== null ? alertHeader : ""}
              message={this.state.unavailable.title !== null ? alertMessage : ""}
            />
            <IonModal
              mode="ios"
              id="drugPopover"
              isOpen={this.state.drugModalVisible}
              onDidDismiss={() => this.toggleDrugModal(false)}
            >
              <IonHeader>
                <IonToolbar mode="ios" color="#F7961E" className="modalHeader navBar">
                  <IonTitle className="headerTitle">{modalTitle}</IonTitle>
                  <IonButtons slot="end">
                    <IonButton aria-label="Close" className="headerButtons" onClick={() => this.toggleDrugModal(false)}>
                      <img className="icon-44" src={buttonClose} />
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent ref={this.ionContentDrugModal} scrollEvents={true} onIonScroll={this.handlePageScroll}>
                <div className={`ACCEGuidelineTitle ${DataController.getGuidelineClass(guidelineSummary)}`}>
                  <div
                    className="globalContentMargin"
                    style={{ fontSize: this.fontSize(22) }}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                </div>
                <div className="padding drugModalContent">
                  {this.state.drugModalTable !== null ? (
                    <div
                      style={{ marginBottom: 20, fontSize: this.fontSize(16) }}
                      dangerouslySetInnerHTML={{ __html: this.state.drugModalTable }}
                    />
                  ) : null}
                </div>
              </IonContent>
              <div className="appColorOverlay" />
            </IonModal>

            <IonModal
              mode="ios"
              id="drugPopover"
              isOpen={this.state.drug2ModalVisible}
              onDidDismiss={() => this.toggleDrug2Modal(false)}
            >
              <IonHeader>
                <IonToolbar mode="ios" color="#F7961E" className="modalHeader navBar">
                  <IonTitle className="headerTitle">{modalTitle}</IonTitle>
                  <IonButtons slot="end">
                    <IonButton
                      aria-label="Close"
                      className="headerButtons"
                      onClick={() => this.toggleDrug2Modal(false)}
                    >
                      <img className="icon-44" src={buttonClose} />
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
              </IonHeader>
              <IonContent ref={this.ionContentDrugModal2} scrollEvents={true} onIonScroll={this.handlePageScroll}>
                <div className={`ACCEGuidelineTitle ${DataController.getGuidelineClass(guidelineSummary)}`}>
                  <div
                    className="globalContentMargin"
                    style={{ fontSize: this.fontSize(22) }}
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                </div>
                <div className="padding drugModalContent drugModal2">
                  {this.state.drug2ModalTable !== null ? (
                    <div
                      style={{ marginBottom: 20, fontSize: this.fontSize(16) }}
                      dangerouslySetInnerHTML={{ __html: this.state.drug2ModalTable }}
                    />
                  ) : null}
                </div>
              </IonContent>
              <div className="appColorOverlay" />
            </IonModal>

            {window.innerWidth < 600 ? (
              <IonModal
                mode="ios"
                id="fontModal2"
                showBackdrop={true}
                isOpen={this.state.fontModalVisible}
                initialBreakpoint={1}
                breakpoints={[0, 1]}
                // event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonModal>
            ) : (
              <IonPopover
                mode="ios"
                id="fontModal"
                showBackdrop={false}
                isOpen={this.state.fontModalVisible}
                event={this.state.fontModalEvent}
                backdropDismiss={true}
                onDidDismiss={() => this.toggleFontModal(false, null)}
              >
                <div className="triangle" />
                <FontPopover features={this.props.features} screenProps={this.props.screenProps} />
              </IonPopover>
            )}

            <IonPopover
              id="abbreviationModal"
              showBackdrop={true}
              isOpen={this.state.abbreviationPopoverVisible}
              event={this.state.abbreviationPopoverEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleAbbreviationPopover(false, null, null)}
            >
              <div className="triangle" />
              {this.state.selectedAbbreviation ? (
                <div className="abbreviationPopoverContainer">
                  <div className="abbreviationPopoverTitle">{this.state.selectedAbbreviation.Title}</div>
                  <div className="abbreviationPopoverText">{this.state.selectedAbbreviation.Text}</div>
                </div>
              ) : null}
            </IonPopover>

            <IonPopover
              mode="ios"
              id="bookmarkSuggestionModal"
              showBackdrop={false}
              isOpen={this.state.bookmarkSuggestionModalVisible}
              event={this.state.bookmarkSuggestionModalEvent}
              backdropDismiss={true}
              onDidDismiss={() => this.toggleBookmarkSuggestionModal(false, null)}
            >
              <div className="triangle" />
              <div className="bookmark-suggestion-modal-container">
                Bookmark guidelines for faster access from your Dashboard
                <div
                  onClick={() => this.toggleBookmarkSuggestionModal(false, null)}
                  className="bookmark-suggestion-modal-dismiss"
                >
                  Dismiss
                </div>
              </div>
            </IonPopover>

            <ImageViewerModal
              isOpen={this.state.imageModalVisible}
              isBookmarked={isBookmarked}
              isReferenceCard={this.state.isReferenceCard}
              referenceCardImageTags={referenceCardImageTags}
              imageSrc={this.state.imageSrc}
              toggleImageModal={this.toggleImageModal.bind(this)}
              bookmarkButtonPressed={this.bookmarkButtonPressed.bind(this)}
              tab={this.props.match.params.tab}
            />
          </div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(withIonLifeCycle(GuidelinePage));
